import {
    mutationsTypes
} from '@/store/mutation-types';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import ClassicEditor from '../util/ckeditor';
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br';
import ApiBotService from '../services/ApiBotService';
import html2canvas from 'html2canvas';
import introJs from "intro.js";
import moment from "moment";
import momenttz from "moment-timezone";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MD5 from "crypto-js/md5"
import {
    reactive,
    computed,
    onBeforeUnmount,
    onMounted,
    ref,
    watch
} from "vue";
import {
    useRouter
} from 'vue-router';
import {
    useToast
} from "vue-toastification";
import {
    useStore
} from "vuex";
import app from "../assets/js/app";
import Emoji from "../components/Emoji.vue";
import InputChips from "../components/InputChips.vue";
import router from '../router';
import CampanhaService from "../services/CampanhaService";
import ChatService from "../services/ChatService";
import HsmService from "../services/HsmService";
import ListService from "../services/ListService";
import TabulacaoService from '../services/TabulacaoService';
import UsuarioService from "../services/UsuarioService";
import NumeroEnterpriseService from '../services/NumeroEnterpriseService';
import TagService from '../services/TagService';
import MarketplaceService from "../services/MarketplaceService";
import HermesApiService from "../services/HermesApiService";
import MessageService from "../services/MessageService";
import store from '../store';
import constants from '../util/constants';
import Validar from "../util/Validadores";
import Atendimento from './Atendimento';
import Cliente from './Cliente';
import Agenda from './Agenda';
import Historico from './HistoricoAtendimento';
import BuscaHistorico from './BuscaHistorico';
import BuscaHistoricoHsm from './BuscaHistoricoHsm';

import {v4 as uuidv4} from 'uuid'
import Modal from "../components/Modal";
import MentionedMessage from "../components/MentionedMessage";
import HeaderTicket from "../components/HeaderTicket";
import {
    useI18n
} from 'vue-i18n'
import Marketplace from './Marketplace';
import paneas from '../services/PaneasService';

const MicRecorder = require('mic-recorder-to-mp3');
const toast = useToast();
export default {
    name: "Home",
    components: {
        Emoji,
        Atendimento,
        InputChips,
        Cliente,
        Agenda,
        Modal,
        Historico,
        BuscaHistorico,
        BuscaHistoricoHsm,
        MentionedMessage,
        Marketplace,
        HeaderTicket,
    },
    setup() {
        const recorder = ref(null);
        const {
            tm,
            locale
        } = useI18n()
        app.init();
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        const store = useStore();
        store.commit('setUsuario', JSON.parse(localStorage.getItem("usuario")));
        const token = localStorage.getItem("token");
        const router = useRouter();
        const loading = ref(null);
        const listHSM = ref([]);
        const hsmSelected = ref("");
        const statusSelected = ref((0)); //ref((localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).statusId : 0));
        const tabulacaoSelected = ref(0);
        const tabulacaoSelected2 = ref(0);
        const campanhasFilter = ref([]);
        const motivosFilter = ref([]);
        const message = ref("");
        const idDinModalSair = ref("");
        const fileSelected = ref("");
        const fileAnexo = ref("");
        const listCampanhasAtivas = ref([]);
        const objFimAtendimento = ref([]);
        const campanhaSelected = ref("");
        const campanhaTransfSelected = ref("");
        const listAgentes = ref([]);
        const minhaCampanha = ref([]);
        const agenteSelected = ref(0);
        const dataAgendamentoTicket = ref("");
        const timezoneDefault = ref("");
        const selectedParams = ref([]);
        const listTopicos = ref([]);
        const topicoSelected = ref(0);
        const listMsgRapidas = ref([]);
        const listTabulacoes = ref([]);
        const listTabulacoes2 = ref([]);
        const msgRapidaSelected = ref("");
        const nextAction = ref("");
        const flagAtendimento = ref(false);
        const campanhaSelecionada = ref(null);
        const remetenteAlterado = ref([]);
        const filaNovaMensagem = ref([]);
        const instantMessages = ref([]);
        const allMessages = ref([]);
        const showInstanMessages = ref(false);
        const lastNotifications = ref([]);
        const content = [];
        const isRecording = ref(false);
        const gravacaoPronta = ref(false);
        const audioGravado = ref(null);
        const audioPreview = ref(null);
        const fimDaConversa = ref(null);       
        const toggleAppbarMobile = ref(false);
        const showIntroRef = ref(false);
        const showBotaoRolagem = ref(false);
        const timeText = ref("");
        const novoRemetenteEmail = ref([]);
        const agentAlertados = ref([]);
        const timeRecording = ref(null);
        const campanha = ref(0);
        const numero = ref("");
        const listaChat = ref([]);
        const temaEscuro = ref((sessionStorage.getItem('temaEscuro') ? JSON.parse(sessionStorage.getItem('temaEscuro')) : false));
        const temaMutant = ref((sessionStorage.getItem('temaMutant') ? JSON.parse(sessionStorage.getItem('temaMutant')) : false));
        const isEmbedded = ref((sessionStorage.getItem('isEmbedded') ? JSON.parse(sessionStorage.getItem('isEmbedded')) : false));
        const listaAnexoEmail = ref([]);
        const editor = ref(ClassicEditor);
        const editorConfig = ref({
            language: 'pt-br',
            placeholder: 'Digite aqui a resposta.',
        });
        const clienteAvailable = ref(false);
        const isloadingEmail = ref(false);
        const isLoadingConection = ref(false);
        const maxAtendimento = ref(0);
        const loadingAlerta = ref(null);
        const loadingSaidaUsuario = ref(null);
        const loadingStatusUsuario = ref([null]);
        const agendaAvailable = ref(false);
        const autocadastrozappag = ref(false);
        const telefoneAtendimento = ref("");
        const numeroEnterprise = ref(null);
        const numeroEnterpriseGupshup = ref(null);
        const msgRapidaAvailable = ref(true);
        const isLoadingAtendimento = ref(false);
                const listMotivoTransf = ref([]);
        const motivoSelected = ref(null);
        const avisoAthFinalizado = ref(false);
        const tagsAvailable = ref(false);
        const autocompleteTag = ref("");
        const autocompleteTags = ref([]);
        const autocompleteItems = ref([]);
        const tagsCadastroAvailable = ref(false);
const qtdNewMsg = ref([]);
        const listAgentMsg = ref([]);
        const historicoAvailable = ref(false);
        const historicoHsmAvailable = ref(false);
        const atendimentoPorIndicadores = ref(false);
        const msgAlarmeAgente = ref("");
        const msgAlarmeCliente = ref("");
        const timeoutLastMessage = ref({});
        const stateLocal = reactive({
            showModalSearchHistoryMessages: false,
            showModalSearchHistoryMessagesHsm: false,
            search: "",
            dadosQueus: [],
            funcaoBuscaAtendimento: false,
            funcaoBuscaAtendimentoHsm: false,
            profilePassword: localStorage.getItem("senhaPadrao") == "true" ? true : false,
            current_password: "",
            new_password: "",
            confirm_password: "",
            operadorDesmarcarCampanha: false,
            numero_pedido: undefined,
            todosMotivo: "TODOS"
        });
        //Computed
        const searchValue = computed({
            get: () => store.state.search,
            set: (value) => store.commit("setSearch", value),
        });

        const selectedWhatsApp = computed({
            get() {
              return store.state.search; // Pegando o valor do Vuex (search)
            },
            set(value) {
              store.commit('setSearch', value); // Atualizando o valor no Vuex (search)
            }
        });

        const nomeUsuario = computed(() => {
            if (store.state.usuario) {
                return store.state.usuario.nome;
            }
            return "";
        });
        const emailUsuario = computed(() => {
            if (store.state.usuario) {
                return store.state.usuario.email;
            }
            return "";
        });

        const campanhaUsuario = computed(() => {
            if (store.state.campanhaUsuario && store.state.campanhaUsuario.length > 0 && store.state.campanhaUsuario[0].nome_Campanha_var.lenght > 1) {
                return tm('nomeCampanha') + store.state.campanhaUsuario[0].nome_Campanha_var;
            }
            return "";

        });

        const mensagemCampanhaUsuario = computed(() => {
            if (store.state.campanhaUsuario && store.state.campanhaUsuario.length > 0) {
                return store.state.campanhaUsuario[0].msg_Atendimento_Campanha_var;
            }
            return "";

        });

        const empresaUsuario = computed(() => {
            if (store.state.usuario && store.state.usuario.empresa) {
                return store.state.usuario.empresa.nomeFantasia;
            }
            return "";
        });
        const supervisorUsuario = computed(() => {
            if (store.state.usuario && store.state.usuario.supervisor) {
                return store.state.usuario.supervisor.nome;
            }
            return "";
        });
        const currentChatQueueSemMotivacao = computed(() => {
            let retorno = []
            for (const chat of store.state.chatsTableData.filter(filterByCampanha)) {
                if (!chat.customVariables || chat.customVariables['@motivo'] === undefined || chat.customVariables['@motivo'] === "" ||
                    !listCategorizada.value.find(element => element === chat.customVariables['@motivo']))
                    retorno.push(chat)
            }
            return retorno
        })

        const currentChatQueue = computed(() => {
            stateLocal.dadosQueus = store.state.chatsTableData.filter(filterByCampanha);
            return store.state.chatsTableData.filter(filterByCampanha);
        });

        const selectedChatQueue = computed(() => {
            app.appBarDrawer();
            // Modificanod filtro de dias
            let listNumeros = document.getElementsByClassName('contacts-item');
            for (let i of listNumeros) {
                let numero = i.firstChild.children[1].children[0].firstChild.innerHTML;
                if(!isNaN(numero))
                {
                    numero = numero.match(/\d+/g).join('');
                }
                else{
                    console.log("Isto não é um numero: ", numero)
                }
                let chatIdSelected = store.state.selectedChatQueue;
                if (chatIdSelected && chatIdSelected.chatId == numero) {
                    i.firstChild.setAttribute("style", "background-color:");
                }
            }
            return store.state.selectedChatQueue;
        });

        const currentChatMessages = computed(() => {
            return store.state.messages;
        });

        const isHsmAvailable = computed(() => {
            let campanhas = store.state.minhasCampanhas;
            for (let key in campanhas) {
                if (campanhas[key].enviaHsm) {
                    return true;
                }
            }
            return false;
        });

        const exibirBtnPuxarAtend = computed(() => {
            let temPuxarAtendimento = false;
            let temFilaAtendimento = false;
            if (store.state.usuario) {
                let confTransf = findConfiguracao("funcao.indicador.fila", store.state.usuario.empresaId);
                if (confTransf.length > 0)
                    temPuxarAtendimento = (confTransf[0].valor ? confTransf[0].valor.toLowerCase() : '') == "true";

                //fetchFilaCampanhas();
                temFilaAtendimento = hasFila();
            }
            return temPuxarAtendimento && temFilaAtendimento;
        });


        const exibirBtnTransferirAtend = computed(() => {
            let temTransferencia = false;
            if (store.state.usuario) {
                let campanha = store.state.minhasCampanhas.find(x => x.nome == selectedChatQueue.value.queueId);
                let campanhaId = campanha ? campanha.id : null
                let confTransf = findConfiguracao("funcao.transferencia", store.state.usuario.empresaId, campanhaId);
                if (confTransf.length > 0)
                    temTransferencia = (confTransf[0].valor ? confTransf[0].valor.toLowerCase() : '') == "true";

                //fetchFilaCampanhas();
            }
            return temTransferencia;
        });

        const exibirBtnDownloadAtend = computed(() => {
            let temChat = false;
            if (store.state.usuario) {
                let campanha = store.state.minhasCampanhas.find(x => x.nome == selectedChatQueue.value.queueId);
                let campanhaId = campanha ? campanha.id : null
                let confChat = findConfiguracao("download.chat.interagev2", store.state.usuario.empresaId, campanhaId);
                if (confChat.length > 0)
                    temChat = (confChat[0].valor ? confChat[0].valor.toLowerCase() : '') == "true";

                //fetchFilaCampanhas();
            }
            return temChat;
        });

        const temFila = computed(() => {
            return store.state.minhasCampanhas.reduce((a, b) => a + (b['fila'] || 0), 0) > 0;
        });

        const isRemetenteAlterado = computed(() => {
            return (remetenteAlterado.value.indexOf(selectedChatQueue.value.chatUUID) !== -1)
        });

        const webFlowConfiguration = computed(() => {
            if (!selectedChatQueue.value)
                return false;
            return (selectedChatQueue.value.channel == constants.TipoCanal.indexOf("FACILITA_FLOW"));
        });

        const atendimentoAvailable = computed(() => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.atendimentohumano", store.state.usuario.empresaId);
                if (conf.length == 0)
                    return false;
                return !!store.state.selectedChatQueue &&
                    selectedChatQueue.value.channel != constants.TipoCanal.indexOf("EMAIL") &&
                    conf[0].valor.toLowerCase() === 'true';
            }
            return false;
        });

        const atendimentoAvailableTutorial = computed(() => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.atendimentohumano", store.state.usuario.empresaId);
                if (conf.length == 0)
                    return false;
                return conf[0].valor.toLowerCase() === 'true';
            }
            return false;
        });


        const exibirBtnEditarRemetente = computed(() => {
            let campanha = store.state.minhasCampanhas.find(x => x.nome == selectedChatQueue.value.queueId);
            let conf = findConfiguracao("funcao.email.editarremetente", store.state.usuario.empresaId, campanha.id);
            if (conf.length == 0)
                return false;
            return conf[0].valor.toLowerCase() === 'true';
        });

        const contactListCategorizada = computed(() => {
            if (store.state.usuario) {
                let campanhas = store.state.minhasCampanhas;
                for (let campanha of campanhas) {
                    let conf = findConfiguracao("funcao.listacontato.categorizada", store.state.usuario.empresaId, campanha.id);
                    if (conf.length != 0 && conf[0].valor.toLowerCase() === 'true') {
                        return true;
                    }
                }
                return false;
            }
            return false;
        });


        const listStatus = computed(() => {
            return store.state.listStatus;
        });

        const showIntro = computed(() => {
            return showIntroRef;
        });

        const listCategorizada = computed(() => {

            if (store.state.usuario) {
                let conf = findConfiguracao("nome.listacontato.categorizada", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    //console.log(conf[0].valor.split("|"))
                    return conf[0].valor.split("|");
                }
            }
            return []
        });

        const refAtendimento = computed(() => {
            if (store.state.usuario) {
                return (store.state.usuario.interacoesSimultaneas != 0 ? store.state.usuario.interacoesSimultaneas : maxAtendimento.value)
            }
            return maxAtendimento.value
        });

        const emojiAvailable = computed(() => {
            let chatSelecionado = selectedChatQueue.value;
            let campanha = store.state.minhasCampanhas.find(x => x.nome == chatSelecionado.queueId);
            if (store.state.usuario) {
                let conf = findConfiguracao("emoji", store.state.usuario.empresaId, campanha.id);
                if (conf.length != 0) {
                    return !!store.state.selectedChatQueue && conf[0].valor.toLowerCase() === 'true';
                }
            }
            return false;
        });

        const filteredItems = computed(() => {
            return autocompleteItems.value.filter(i => {
                return i.text.toLowerCase().indexOf(autocompleteTag.value.toLowerCase()) !== -1;
            });
        });

        const getTimeoutAtendimentoAgente = async (campanha) => {
            let tempoAlarme = []
            if (store.state.usuario) {
                let conf = findConfiguracao("alarme.agente.tempo", store.state.usuario.empresaId, campanha);
                if (conf.length != 0) {
                    tempoAlarme = conf[0].valor;
                }
            }
            return tempoAlarme
        }

        const getTimeoutAtendimentoMsgAgente = async (campanha) => {
            let msgAlarme = []
            if (store.state.usuario) {
                let conf = findConfiguracao("alarme.agente.mensagem", store.state.usuario.empresaId, campanha);
                if (conf.length != 0) {
                    msgAlarme = conf[0].valor;
                }
            }
            return msgAlarme
        }
        const getTimeoutAtendimentoMsgParaCliente = async (campanha) => {
            let msgAlarme = []
            if (store.state.usuario) {
                let conf = findConfiguracao("alarme.cliente.mensagem", store.state.usuario.empresaId, campanha);
                if (conf.length != 0) {
                    msgAlarme = conf[0].valor;
                }
            }
            return msgAlarme
        }
        const headerTicketConfiguration = computed(() => {
            if (!selectedChatQueue.value)
                return false;
            return isMarketplace(selectedChatQueue.value.channel);
        });

        //Watch
        watch(statusSelected, (newVal) => {
            if (store.state.usuario.id && store.state.usuario.empresaId && newVal != 0) {
                store.dispatch('updateStatus', {
                    id: newVal,
                    tm: tm
                })
            } else {
                toast.warning(tm('erroAtualizarStatus'));
            }
        });

        // watch(campanhaSelected, (newVal) => {
        //     listAgentes.value = [];
        //     listMotivoTransf.value = []
        //     motivoSelected.value = null
        //     agenteSelected.value = 0
        //     if (store.state.usuario.empresaId && newVal) {
        //         UsuarioService.GetAgentesDisponiveis(store.state.usuario.empresaId, newVal)
        //             .then(response => {
        //                 listAgentes.value = response.data
        //             }).catch(error => {
        //                 console.debug(error);
        //             });

        //         TabulacaoService.GetTabulacoesByCampanhaAndEmpresa(newVal, store.state.usuario.empresaId, 2)
        //             .then(response => {
        //                 listMotivoTransf.value = response.data
        //             }).catch(error => {
        //                 console.debug(error)
        //             });
        //     }
        // });

        watch(campanhaTransfSelected, (newVal) => {
            campanhaSelected.value = newVal.nome
            listAgentes.value = [];
            listMotivoTransf.value = []
            motivoSelected.value = null
            agenteSelected.value = 0
            if (store.state.usuario.empresaId && newVal.nome) {
                UsuarioService.GetAgentesDisponiveis(store.state.usuario.empresaId, newVal.nome)
                    .then(response => {
                        listAgentes.value = response.data
                    }).catch(error => {
                        console.debug(error);
                    });

                TabulacaoService.GetTabulacoesByCampanhaAndEmpresa(newVal.nome, store.state.usuario.empresaId, 2)
                    .then(response => {
                        listMotivoTransf.value = response.data
                    }).catch(error => {
                        console.debug(error)
                    });
            }
        });

        watch(hsmSelected, (newVal) => {
            selectedParams.value = [];
            if (newVal && newVal.mensagem) {
                const regexp = "{{([0-9]*?)}}";
                const array = [...newVal.mensagem.matchAll(regexp)];
                if (array.length > 0) {
                    for (let i = 0; i < array.length; i++) {
                        let j = i + 1;
                        selectedParams.value.push({
                            chave: "{{" + j + "}}",
                            valor: ""
                        });
                    }
                }
            }
        });

        watch(topicoSelected, (newVal) => {

            listMsgRapidas.value = [];
            if (newVal) {
                ListService.getMensagensRapida(newVal)
                    .then(response => {
                        listMsgRapidas.value = response.data
                    }).catch(error => {
                        console.debug(error);
                    });
            }
            // this.$refs.historicoCmp.dataSelect.dataFinal = new Date();
            // this.$refs.historicoCmp.dataSelect.dataInicial = new Date().addDays(-90);
        });

        watch(tabulacaoSelected, (newVal) => {
            listTabulacoes2.value = [];
            tabulacaoSelected2.value = 0;
            if (newVal) {

                TabulacaoService.GetTabulacoesByParent(newVal)
                    .then(response => {
                        listTabulacoes2.value = response.data
                    }).catch(error => {
                        console.debug(error)
                    });
            }
        });

        watch(message, (newVal) => {
            let filteredMessages = [];
            if (msgRapidaAvailable.value && newVal && allMessages.value && allMessages.value.length > 0) {
                for (let i = 0; i < allMessages.value.length; i++) {
                    if (allMessages.value[i].mensagem.toLowerCase().includes(newVal.toLowerCase())) {
                        filteredMessages.push(allMessages.value[i]);
                    }
                }
            }
            instantMessages.value = filteredMessages;
        });

        watch(temaEscuro, (newVal) => {
            sessionStorage.setItem('temaEscuro', newVal);

        });

        watch(temaMutant, (newVal) => {
            sessionStorage.setItem('temaMutant', newVal);
        });

        watch(selectedChatQueue, (newVal) => {

            if (typeof newVal !== 'undefined' && newVal != null) {

                if (numero.value !== newVal.chatId) {
                    numero.value = newVal.chatId;
                    store.state.appBar = "";
                }
            }
        });

        watch(gravacaoPronta, async (val) => {
            if (val) {
                await nextTick()
                if (fimDaConversa.value && typeof fimDaConversa.value.scrollIntoView === 'function') {
                fimDaConversa.value.scrollIntoView({ behavior: 'smooth' })
                }
            }
        });

        watch(telefoneAtendimento, (newVal) => {

            //console.log("newVal.length ", newVal.length);
            if (newVal.length > 17 && newVal[9] != '9' && store.state.usuario.empresa.paisSigla == 'BR') {
                var numero = newVal.replaceAll('+', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '').replaceAll(' ', '');
                telefoneAtendimento.value = parseInt(numero.substring(0, 4) + '9' + numero.substring(4));

            }
        });

        async function getCampanha() {
            let campanha = store.state.minhasCampanhas.find(x => x.nome == selectedChatQueue.value.queueId);
            let token = store.state.ath.apiBotHub[store.state.selectedChatQueue.chatId].token;
            let camp = await ApiBotService.GetCampanha(token, campanha.id);
            return camp.data.campain_Exists_List;
        }

        //Functions
        function loadData() {
            loading.value = setInterval(async () => {
                if (store.state.usuario) {
                    await getChats();
                    //getChats();
                    await getChatMessages();
                    //getChatMessages();
                    await fetchFilaCampanhas();
                    //fetchFilaCampanhas();
                    atualizaDataHoraKeepAlive();
                    hasFila().then(async (filaResponse) => {
                        let totalEmAtendimento = store.state.chatsTableData.length
                        if (isDesenrola()){
                            let chatResponse = await ChatService.chatQueueActiveAgent(store.state.usuario.id);
                            totalEmAtendimento = chatResponse.data.length;
                        }

                        let statusAtual = listStatus.value.find(x => x.id == store.state.usuario.statusId);
                        if (filaResponse && totalEmAtendimento < refAtendimento.value &&
                            !statusAtual.isPausa && !isLoadingAtendimento.value) {
                            puxarNexAtendimento(totalEmAtendimento);
                        }
                    });
                    if (isEmbedded.value) {
                        let customData = {
                            "func": "loadQtnQueue",
                            "total": store.state.chatsTableData.length,
                            "queue": "",
                            "canal": sessionStorage.getItem("channel") || 0,
                        }
                        window.parent.postMessage(customData,"*");
                    }
                }
            }, 10000);
        };

        function loadAlerta() {
            loadingAlerta.value = setInterval(() => {
                verificaAlertaTimeout();
            }, 2000);
        };

        function loadSaidaUsuario() {
            loadingSaidaUsuario.value = setInterval(() => {
                verificaSaida();
            }, 10000);
        };

        function loadStatusUsuario() {
            loadingStatusUsuario.value = setInterval(() => {
                verificaStatusUsuario();
            }, 3000);
        };

        function setChats() {
            store.commit(mutationsTypes.CHATS);
            getChats();
        }

        function setMotivosFilter(motivo) {
            //console.log(motivo)
            if (motivo === "TODOS" || motivo === undefined) {
                stateLocal.todosMotivo = "TODOS"
            } else {
                stateLocal.todosMotivo = motivo
            }
        }

        async function setChatBody(chats) {
            // Modificanod filtro de dias
            this.$refs.clienteCmp.buscarCliente();
            this.$refs.historicoCmp.resetInfo();
            if (chats) {
                qtdNewMsg.value[chats.chatId] = 0
            }

            setMainTab(true);
            let pos = filaNovaMensagem.value.map(function (e) {
                return e.chatId;
            }).indexOf(chats.chatId);
            if (pos != -1) {
                filaNovaMensagem.value.splice(pos, 1);
            }

            clearMessage();

            if ((chats.channel == constants.TipoCanal.indexOf("EMAIL")) && chats.email.remetenteAlterado === undefined) {
                chats.email.remetenteAlterado = false;
            }

            store.dispatch('setIsNewFalse', chats.chatId);
            store.commit('setChatBody', chats);

            if (tagsAvailable.value) {
                await getTags()
                autocompleteTag.value = ""
                autocompleteTags.value = []
                if (chats.tags && chats.tags.length > 0) {
                    getTagsChat(chats.tags)
                }
            }
            store.commit('setHubConnection', null);
            listaAnexoEmail.value = [];
            isLoadingConection.value = true;
            getChatMessages().then(() => {
                scrollToBottomSelected();
            });
            await store.dispatch('getConection', {
                ath: atendimentoAvailable.value,
                cliente: clienteAvailable.value,
                tm: tm
            });
            if (isEmbedded.value){
                let customerData = {

                    func: "loadFormCustomer",
                    tel: chats.chatId,
                    uuid: chats.uuid,
                    execresposta: chats.customVariables["@Execresposta"] ||"",
                    idconversa: chats.customVariables["@ExternalChatId"] || chats.chatId
                }
                window.parent.postMessage(customerData,"*");
            }
            if (!isEmbedded.value && atendimentoAvailable.value) await store.dispatch('getCampanha', chats.chatId);
            isLoadingConection.value = false
            /* getChatMessages().then(() => {
                scrollToBottom();
            }); */

        }

        //async function enviarMensagemInicial(chats, agenteNome = undefined, campanhaDestino=null) {
        function enviarMensagemInicial(chats, agenteNome = undefined, campanhaDestino=null) {

            console.log("Enviar Mensagem Inicial: ", chats);
            console.log("Empresa Id: ", chats.empresaId);
            console.log("MediaId: ", chats.customVariables.MediaId);
            //console.log("mediaId: ", chats.customVariables.mediaId);
            if (chats.channel == constants.TipoCanal.indexOf("EMAIL") || isMarketplace(chats.channel)) {
                console.log("Canal de Email ou MarketPlace")
                return
            } else {
                
                let campanha = campanhaDestino || store.state.minhasCampanhas.find(x => x.nome == chats.queueId);
                console.log("CampanhaId: ", campanha.id);

                let conf = findConfiguracao("mensagem.conexao", chats.empresaId, campanha.id);
                console.log("Conf: ", conf);

                let configMsgwithEmpresaCampanha = findConfiguracao("mensagem.conexao.campanha", chats.empresaId, campanha.id);
                console.log("Config: ", configMsgwithEmpresaCampanha);

                //let showMessageInicial = configMsgwithEmpresaCampanha == null || configMsgwithEmpresaCampanha.length == 0 ? true: configMsgwithEmpresaCampanha[0].valor.toLowerCase() == "true";
                let showMessageInicial = 
                    (configMsgwithEmpresaCampanha != null || configMsgwithEmpresaCampanha == 0) && 
                    (configMsgwithEmpresaCampanha[0].valor.toLowerCase() == "true")
                
                ? true : false;
                
                console.log("ShowMessageInicial: ", showMessageInicial);

                agenteNome = agenteNome || store.state.usuario.nome

                console.log("Agente nome: ", agenteNome);

                if (conf.length > 0 && showMessageInicial) {
                    let mensagemInicial = conf[0].valor.trim().replace("{0}", agenteNome);
                    chats.agentId = "";
                    console.log("SengMessageChatId");
                    //await sendMessageChatId(chats, mensagemInicial)
                    sendMessageChatId(chats, mensagemInicial)
                }
            }
        }
        function enviarMensagemDeTransferencia(chats, campanhaDestino=null) {

            console.log("Enviar Mensagem de Transferência: ", chats);
            console.log("Empresa Id: ", chats.empresaId);
            console.log("MediaId: ", chats.customVariables.MediaId);

            if (chats.channel == constants.TipoCanal.indexOf("EMAIL") || isMarketplace(chats.channel)) {
                console.log("Canal de Email ou MarketPlace")
                return
            } else {
                
                let campanha = campanhaDestino || store.state.minhasCampanhas.find(x => x.nome == chats.queueId);
                console.log("CampanhaId: ", campanha.id);

                let conf = findConfiguracao("mensagem.conexao.transferencia", chats.empresaId, campanha.id);
                console.log("config: ", conf)
                
                var agenteNome = store.state.usuario.nome

                console.log("Agente nome: ", agenteNome);

                if (conf.length > 0) {
                    console.log("entrou para executar o envio de msg")
                    let dataAtual = new Date();
                    let formatoBrasil = dataAtual.toLocaleString("pt-BR");
                    console.log("formatou a data")
                    let mensagemInicial = conf[0].valor.trim().replace("{0}", agenteNome).replace("{1}", formatoBrasil);
                    chats.agentId = "";
                    console.log("SengMessageChatId -> ", mensagemInicial);
                    //sendMessageChatId(chats, mensagemInicial)
                    addToChatHistory(mensagemInicial, chats)

                }
            }
        }

        function isNewAtendimento(chatId) {
            let isNew = localStorage.getItem('isNew') ? JSON.parse(localStorage.getItem("isNew")) : []
            favicon(isNew);
            let itemNew = undefined
            if (isNew.length > 0) {
                itemNew = isNew.find(x => x.chave == chatId);
            }
            if (!itemNew) {
                let item = {
                    chave: chatId,
                    valor: true
                }
                isNew.push(item)
                localStorage.setItem("isNew", JSON.stringify(isNew))
                notifyMe()
                return true
            } else {
                return itemNew.valor
            }
        }

        function setProfile() {
            // if (isloadingEmail.value) {
            //   return false;
            // }
            store.commit('setChatBody', null);
            if (tagsAvailable.value) {
                autocompleteItems.value = []
                autocompleteTag.value = ""
                autocompleteTags.value = []
            }
            store.commit(mutationsTypes.PROFILE);
            //console.log("Store ", store);
        }

        function setTranslator() {
            store.commit(mutationsTypes.TRANSLATOR);
        }

        function setNotes() {
            store.commit(mutationsTypes.NOTES);
        }

        function setTodo() {
            store.commit(mutationsTypes.TODO);
        }

        function setSettings() {
            store.commit(mutationsTypes.SETTINGS);
        }

        function setHistorico() {
            // carregar os chatQueues do período
            //this.$refs.HistoryCmp.getDados(datainicial, dataFinal, chatIds);
            //this.$refs.clienteCmp.getDadosCliente();
            //let dataInicial = new Date().addDays(-90);
            //let dataFinal = new Date();
            this.$refs.historicoCmp.carregarDadosChats();
            store.commit(mutationsTypes.HISTORICO);
        }
        function setHistoricoHsm() {
            
            this.$refs.historicoCmpHsm.carregarDadosChats();
            console.log(">>>> setHistoricoHsm")
            store.commit(mutationsTypes.HISTORICO_HSM);
        }

        function setBusca() {
            stateLocal.showModalSearchHistoryMessages = true;
            console.log("SelectedWhatsAPP: ", selectedWhatsApp.value);
        }
         function setBuscaHsm() {
            stateLocal.showModalSearchHistoryMessagesHsm = true;
            console.log("SelectedWhatsAPP: ", selectedWhatsApp.value);
        }

        function setProfilePassword() {
            stateLocal.profilePassword = true;
        }

        function clearFieldsPass() {
            stateLocal.current_password = "";
            stateLocal.new_password = "";
            stateLocal.confirm_password = "";
        }

        async function saveChangesPass() {

            if (stateLocal.current_password.trim() == "") {
                toast.warning(tm('erroSenhaAtual'));
                return;
            }

            if (stateLocal.new_password.trim() == "") {
                toast.warning(tm('erroNovaSenha'));
                return;
            }

            if (stateLocal.confirm_password.trim() == "") {
                toast.warning(tm('erroConfirmaSenha'));
                return;
            }

            if (stateLocal.new_password.trim() != stateLocal.confirm_password.trim()) {
                toast.warning(tm('erroNovaSenhaDifConfirma'));
                return;
            }

            try {
                let response = await UsuarioService.ChangePassword(
                    store.state.usuario.id,
                    MD5(stateLocal.current_password.trim()).toString(),
                    MD5(stateLocal.new_password.trim()).toString()
                );

                toast.info(tm('msgTrocaSenha'));

                clearFieldsPass();

                stateLocal.profilePassword = false;
                localStorage.removeItem("senhaPadrao");

            } catch (error) {

                if (error.data == 1 || error.data == 2 || error.data == 3) {
                    toast.error(tm('erroTrocaSenha0' + error.data.toString()));
                } else {
                    toast.error(tm('erroTrocaSenha99'));
                }

            }

        }

        async function setAtendimento() {
            if (store.state.selectedChatQueue && clienteAvailable.value) {
                this.$refs.clienteCmp.getDadosCliente()
            }
            this.$refs.atendimentoCmp.forceRerender("secoes");
            store.commit(mutationsTypes.ATENDIMENTO);
        }
        
        function setCliente() {
            this.$refs.clienteCmp.setaAtocadastrozappag(autocadastrozappag.value)
            this.$refs.clienteCmp.setAth(atendimentoAvailable.value)
            this.$refs.clienteCmp.getDadosCliente()
            store.commit(mutationsTypes.CLIENTE);
        }
        async function setAgenda() {
            if (store.state.selectedChatQueue && clienteAvailable.value) {
                this.$refs.clienteCmp.getDadosCliente()
            }
            await getMinhasAgendas()
            await this.$refs.agendaCmp.setAgendaFilter(store.state.minhasAgendas)
            this.$refs.agendaCmp.setaAtocadastrozappag(autocadastrozappag.value)
            this.$refs.agendaCmp.fetchEvents({
                view: 'day',
                startDate: moment().startOf('day')._d,
                endDate: moment().endOf('day')._d,
                week: ''
            })
            store.commit(mutationsTypes.AGENDA);
        }

        function appBarClear() {
            store.commit('appBarClear');
            store.commit('ath/setOpcao', 'secoes');

        }

        function setMainTab(value) {
            store.commit('setMainTab', value);
        }

        async function logout() {
            if (!store.state.chatsTableData || store.state.chatsTableData.length == 0) {
                if (atendimentoPorIndicadores.value) {
                    await ChatService.IndicadoresLogout(store.state.usuario.id, store.state.usuario.empresaId);
                }
                await finishUserSession();
                localStorage.removeItem("isNew");
                localStorage.removeItem("countProduct");
                router.push("Login");
            } else {
                toast.warning(tm('erroLogout'));
            }
        }
        function EhNumeroInternacional(numero)
        {
            console.log("numero::::", numero)
            return !numero.toString().startsWith("55");
        }
    
        function sendHsm() {
            let camposInvalidos = selectedParams.value.filter(param => !param.valor);
            const regex = /^(\d{13}|\+\d{2} \(\d{2}\) \d{4,5}-\d{4})$/;
        
            if (!selectedWhatsApp.value) {
                toast.warning(tm('erroWhatsapp'));
            }else if(!EhNumeroInternacional(selectedWhatsApp.value) && !regex.test(selectedWhatsApp.value)){
                toast.warning(tm('erroWhatsappFormato'));
            } else if (camposInvalidos.length > 0) {
                toast.warning(tm('erroParams'));
            } else {
                ChatService.chatQueueActiveNumber(selectedWhatsApp.value, store.state.usuario.empresaId).then(response => {
                    if (response && Array.isArray(response.data) && response.data.length > 0) {
                        toast.warning(tm('erroNumeroAtivo'));
                    } else {
                        let params = "";
                        for (let key in selectedParams.value) {
                            params += selectedParams.value[key].valor + "|";
                        }
                        if (params != "") {
                            params = params.substring(0, params.length - 1);
                        }
                        HsmService.AddHsm({
                            destinatario: selectedWhatsApp.value,
                            mensagem: hsmSelected.value.mensagem,
                            dataInclusao: moment().format(),
                            remetente: store.state.usuario.nome,
                            parametro: params,
                            mensagemsalvaId: hsmSelected.value.id,
                            usuarioId: store.state.usuario.id
                        }).then(response => {
                            toast.info(tm('hsmInserido'));
                            clearHsm();
                        }).catch(error => {
                            toast.warning(tm('erroHsm'));
                        });
        
                        $(this.$refs.modalHsm).modal('toggle');
                    }
                }).catch(error => {
                    toast.warning(tm('erroVerificarFila'));
                    console.error("Erro ao verificar número ativo:", error);
                });
            }
        }

        function clearHsm() {

            hsmSelected.value = "";
            selectedWhatsApp.value = "";
            selectedParams.value = [];
        }
            async function sendMessage(event, email) {
            //function sendMessage(event, email) {
                console.log("Método sendMessage");
                flagAtendimento.value = true;
                let chatSelecionado = selectedChatQueue.value
                console.log("ChatSelecionado: ", chatSelecionado);
                //const mediaId = chatSelecionado.MediaId;
                let mediaId = chatSelecionado.customVariables && chatSelecionado.customVariables['MediaId'] ?
                    chatSelecionado.customVariables['MediaId'] : localStorage.getItem("mediaId");
                console.log("Media Id SendMessage: ", mediaId);
                console.log(`Media Id Custom Variable: ${chatSelecionado.customVariables.mediaId} ou ${chatSelecionado.customVariables["MediaId"]}`);
                if (event) {
                event.preventDefault()
            }
            if ((message.value && message.value.trim() != "") || email) {
                let msg = message.value.trim();
                clearMessage();
                if (chatSelecionado.channel === constants.TipoCanal.indexOf("WHATSAPP") || chatSelecionado.channel === constants.TipoCanal.indexOf("WHATSAPPBUSINESS")) {
                    //Ivanildo Bacelar - Se empresa da Paneas enviar via api deles
                    console.log("MediaId: ", chatSelecionado.MediaId)
                    console.log("mediaId: ", chatSelecionado.mediaId)
                    if (isMessageSendByPaneas(chatSelecionado.empresaId) == true || isMessageSendByGupshup(chatSelecionado.empresaId, mediaId) == true) {
                        //await sendMessageChatId(chatSelecionado, msg);
                        sendMessageChatId(chatSelecionado, msg);
                        return
                    }

                    try {
                        console.log('Try')
                        const r = store.dispatch('sendMessageHermesClient', { //await store.dispatch('sendMessageHermesClient', {
                            msg: msg,
                            chatQueue: chatSelecionado,
                        })
                        if (timeoutLastMessage.value.lenght > 0) {
                            timeoutLastMessage[chatSelecionado.chatId]["flag"] = true;
                        }

                        await addToChatHistory(msg, chatSelecionado, undefined, r);
                        //addToChatHistory(msg, chatSelecionado, undefined, r);
                    } catch (e) {
                        console.log(e)
                        toast.warning(tm('erroEnviarMensagem'));
                    }
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("TELEGRAM")) {
                    store.dispatch('sendMessageTelegram', {
                        msg: msg,
                        chatId: chatSelecionado
                    })
                        .then((r) => {
                            return addToChatHistory(msg, chatSelecionado);
                        }).catch((e) => {
                            toast.warning(tm('erroEnviarMensagem'));
                        });
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("WEBCHAT")) {

                    if (isMessageSendByPaneas(chatSelecionado.empresaId) == true || isMessageSendByGupshup(chatSelecionado.empresaId) == true) {
                        //await sendMessageChatId(chatSelecionado, msg);
                        sendMessageChatId(chatSelecionado, msg);
                        return
                    }

                    let hub = store.dispatch('getConectionChat', { //await store.dispatch('getConectionChat', {
                        chatQueue: chatSelecionado
                    });
                    const response = store.dispatch('sendMessageChatHubChatId', { //await store.dispatch('sendMessageChatHubChatId', {
                        msg: msg,
                        chatQueue: chatSelecionado,
                        hub: hub
                    });
                    if (!response) {
                        toast.warning(tm('erroEnviarMensagem'));
                    } else {
                        return addToChatHistory(msg, chatSelecionado)
                    }
                } else if (isMarketplace(chatSelecionado.channel)) {
                    const respMarketplace = addToMarketplace(msg, chatSelecionado) //await addToMarketplace(msg, chatSelecionado)
                    if (!respMarketplace) {
                        toast.warning(tm('erroEnviarMensagem'));
                    } else {
                        return addToChatHistory(msg, chatSelecionado)
                    }
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("FACEBOOK") ||
                    chatSelecionado.channel === constants.TipoCanal.indexOf("INSTAGRAM")) {
                    const respFacebook = addToSocialNetwork(msg, chatSelecionado) //await addToSocialNetwork(msg, chatSelecionado)
                    if (!respFacebook) {
                        toast.warning(tm('erroEnviarMensagem'));
                    } else {
                        return addToChatHistory(msg, chatSelecionado)
                    }
                } else {
                    return addToChatHistory(msg, chatSelecionado, email);
                }
            }
        }

        function clearMessage() {
            message.value = "";
        }

        function clearFile() {
            fileSelected.value = "";
            fileAnexo.value = "";
        }

        async function sendProductDescription(listaProduto) {
            let chatSelecionado = selectedChatQueue.value
            for (let [i, produto] of listaProduto.entries()) {
                let count = await store.dispatch('ath/incrementCountProduct', chatSelecionado.chatId)
                let nomeProd = produto.sortimento ? produto.nomeProduto + ' - ' + produto.sortimento : produto.nomeProduto
                let msgImagem = "";
                if (produto.precoAntigo && produto.precoAntigo > produto.precoProduto) {
                    msgImagem = "IMAGE|" + produto.imagemProduto + "|" + count + ' - ' + nomeProd + " - DE: R$ " + produto.precoAntigo + " POR: R$ " + produto.precoProduto
                } else {
                    msgImagem = "IMAGE|" + produto.imagemProduto + "|" + count + ' - ' + nomeProd + " - R$" + produto.precoProduto
                }
                if (chatSelecionado.channel === constants.TipoCanal.indexOf("WHATSAPP") || chatSelecionado.channel === constants.TipoCanal.indexOf("WHATSAPPBUSINESS")) {
                    try {
                        const r = await store.dispatch('sendFileHermesClient', {
                            file: msgImagem,
                            chatQueue: chatSelecionado
                        })
                        await addToChatHistory(msgImagem, chatSelecionado, undefined, r);
                        toast.info(tm('sucessoEnviarMsg'));
                    } catch (e) {
                        //console.log(e)
                        toast.warning(tm('erroEnviarMensagem'));
                        message.value = msgImagem;
                    };
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("TELEGRAM")) {
                    try {
                        const r = await store.dispatch('sendMessageTelegram', {
                            msg: msgImagem,
                            chatQueue: chatSelecionado
                        })
                        await addToChatHistory(msgImagem, chatSelecionado);
                        toast.info(tm('sucessoEnvioMsg'));
                    } catch (e) {
                        //console.log(e);
                        toast.warning(tm('erroEnviarMensagem'));
                        message.value = msgImagem;
                    }
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("WEBCHAT")) {
                    let hub = await store.dispatch('getConectionChat', {
                        chatQueue: chatSelecionado
                    });
                    const response = await store.dispatch('sendMessageChatHubChatId', {
                        msg: msgImagem,
                        chatQueue: chatSelecionado,
                        hub: hub
                    });
                    // const response = await sendMessageChatHub(msgImagem);
                    if (!response) {
                        toast.warning(tm('erroEnviarMensagem'));
                    } else {
                        return addToChatHistory(msgImagem, chatSelecionado)
                    }
                } else if (isMarketplace(chatSelecionado.channel)) {
                    const respMarketplace = await addToMarketplace(msgImagem, chatSelecionado)
                    if (!respMarketplace) {
                        toast.warning(tm('erroEnviarMensagem'));
                    } else {
                        return addToChatHistory(msgImagem, chatSelecionado)
                    }
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("FACEBOOK") ||
                    chatSelecionado.channel === constants.TipoCanal.indexOf("INSTAGRAM")) {
                    const respFacebook = await addFileToSocialNetwork(msgImagem, chatSelecionado)
                    if (!respFacebook) {
                        toast.warning(tm('erroEnviarArquivo'));
                    } else {
                        return addToChatHistory(msgImagem, chatSelecionado)
                    }
                } else {
                    return addToChatHistory(msgImagem, chatSelecionado);
                }
            }
        }

        async function sendAnexo(tipo) {
            let chatSelecionado = selectedChatQueue.value
            let msg = "";
            let fileType = "";
            let nomeArquivo = ""
            switch (tipo) {
                case 'inputImage':
                    msg = 'IMAGE|';
                    fileType = 'image';
                    nomeArquivo = fileSelected.value.name;
                    break;
                case 'inputAudio':
                    msg = 'AUDIO|'
                    fileType = 'audio';
                    nomeArquivo = fileSelected.value.name;
                    break;
                case 'inputVideo':
                    msg = 'VIDEO|';
                    fileType = 'video';
                    nomeArquivo = fileSelected.value.name;
                    break;
                case 'inputDocument':
                    msg = 'DOCUMENT|';
                    fileType = 'document';
                    nomeArquivo = fileSelected.value.name;
                    break;
                case 'inputVoice':
                    msg = 'AUDIO|'
                    fileType = 'audio';
                    nomeArquivo = "source.mp3"
                    break;
                default:
                    break;
            };
            let splitNome = nomeArquivo.split(".");
            let extension = splitNome[splitNome.length - 1];
            let texto = ''
            let x = document.getElementsByClassName('avatar');
            for (let i = 0; i < splitNome.length - 1; i++) {
                texto = texto + splitNome[i]
            }
            let path = chatSelecionado.flowUUID + "/" + fileType + "/";
            let base64 = fileAnexo.value.split(";base64,")[1];
            try {
                const data = await ChatService.AddFileChat({    
                    path: path,
                    base64: base64,
                    extension: extension
                });
                msg = msg + data.data.url + '|' + texto;
                if (chatSelecionado.channel === constants.TipoCanal.indexOf("WHATSAPP") || chatSelecionado.channel === constants.TipoCanal.indexOf("WHATSAPPBUSINESS")) {
                    if (isMessageSendByPaneas(chatSelecionado.empresaId) == true || isMessageSendByGupshup(chatSelecionado.empresaId) == true) {
                        await sendMessageChatId(chatSelecionado, msg);
                        return
                    }
                    try {
                        const r = await store.dispatch('sendFileHermesClient', {
                            file: msg,
                            chatQueue: chatSelecionado,
                        })
                        await addToChatHistory(msg, chatSelecionado, undefined, r);
                    } catch (e) {
                        //console.log(e)
                        toast.warning(tm('erroEnviarArquivo'));
                        message.value = msg;
                    }
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("TELEGRAM")) {
                    store.dispatch('sendMessageTelegram', {
                        msg: msg,
                        chatId: chatSelecionado
                    })
                        .then((r) => {
                            return addToChatHistory(msg, chatSelecionado);
                        }).catch((e) => {
                            //console.debug(e)
                            toast.warning(tm('erroEnviarArquivo'));
                        });
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("WEBCHAT")) {

                    if (isMessageSendByPaneas(chatSelecionado.empresaId) == true || isMessageSendByGupshup(chatSelecionado.empresaId) == true) {
                        await sendMessageChatId(chatSelecionado, msg);
                    } else {
                        let hub = await store.dispatch('getConectionChat', {
                            chatQueue: chatSelecionado
                        });
                        const resp = await store.dispatch('sendMessageChatHubChatId', {
                            msg: msg,
                            chatQueue: chatSelecionado,
                            hub: hub
                        });
                        // const resp = await sendMessageChatHub(msg);
                        if (!resp) {
                            toast.warning(tm('erroEnviarArquivo'));
                        } else {
                            addToChatHistory(msg, chatSelecionado);
                        }
                    }
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("EMAIL")) {
                    let r = Math.random().toString(36).substring(7);
                    let anexoEmail = {
                        id: r,
                        nome: nomeArquivo,
                        caminhoUrl: data.data.url,
                        tamanho: fileSelected.value.size
                    }
                    listaAnexoEmail.value.push(anexoEmail)
                } else if (isMarketplace(chatSelecionado.channel)) {
                    const respMarketplace = await addToMarketplace(msg, chatSelecionado)
                    if (!respMarketplace) {
                        toast.warning(tm('erroEnviarArquivo'));
                    } else {
                        return addToChatHistory(msg, chatSelecionado)
                    }
                } else if (chatSelecionado.channel === constants.TipoCanal.indexOf("FACEBOOK") ||
                    chatSelecionado.channel === constants.TipoCanal.indexOf("INSTAGRAM")) {
                    const respFacebook = await addFileToSocialNetwork(msg, chatSelecionado)
                    if (!respFacebook) {
                        toast.warning(tm('erroEnviarArquivo'));
                    } else {
                        return addToChatHistory(msg, chatSelecionado)
                    }
                } else {
                    addToChatHistory(msg, chatSelecionado);
                }
            } catch (err) {
                console.debug(err)
                toast.warning(tm('erroEnviarArquivo'));
            }
        };

        function onFileChange(event) {

            var files = event.target.files || event.dataTransfer.files;
            if (!files.length)
                return;

            if (!Validar.tamanhoArquivo(files[0])) {
                toast.warning(tm('erroArquivoTamanho') + files[0].name);
                return;
            }
            if (!Validar.tipoArquivosPermitidos(files[0].name, event.target.name)) {
                toast.warning(tm('erroArquivoFormato') + files[0].name);
                return;
            }
            fileSelected.value = files[0];
            createAnexo(files[0], event.target.name);
            toast.info(tm('arquivo') + " " + files[0].name + " " + tm('carregado') + "!");
        }

        function createAnexo(file, tipo) {
            switch (tipo) {
                case 'inputImage':
                    fileAnexo.value = new Image();
                    break;
                case 'inputAudio':
                    fileAnexo.value = new Audio();
                    break;
                case 'inputVideo':
                    fileAnexo.value = document.createElement("video");
                    break;
                default:
                    break;
            }
            var reader = new FileReader();
            reader.onload = (e) => {
                fileAnexo.value = e.target.result;
            };
            reader.readAsDataURL(file);
        }

        function filterByCampanha(obj) {
            /*//console.log('obj')
            //console.log(obj)
            //console.log(stateLocal.numero_pedido)*/
            if (campanhasFilter.value.find(element => element.nome === obj.queueId &&
                (stateLocal.todosMotivo === "TODOS" || (obj.customVariables && obj.customVariables['@motivo'] && stateLocal.todosMotivo === obj.customVariables['@motivo'])))) {
                if (stateLocal.numero_pedido) {
                    if (obj.customVariables && obj.customVariables['orderid'] && obj.customVariables['orderid'] == stateLocal.numero_pedido) {
                        return true;
                    } else {
                        return false;
                    }
                }
                return true;
            } else {
                return false;
            }
        }

        function filterByMotivo(obj) {
            if (motivosFilter.value.find()) {
                return true;
            } else {
                return false;
            }
        }

        function addToChatHistory(msg, chatQueue, email, resp) {
            var dataFixa = moment('1999-01-01');
            if (chatQueue) {
                let messageId = resp && resp.data && resp.data.message && resp.data.message.id ? resp.data.message.id : null
                let message = {
                    chatUUID: chatQueue.chatUUID,
                    empresaId: chatQueue.empresaId,
                    channel: chatQueue.channel,
                    message: msg,
                    agentId: chatQueue.agentId,
                    chatId: chatQueue.chatId,
                    flowId: chatQueue.flowUUID,
                    stepFlowId: 0,
                    stepName: "Atendimento Humano",
                    incoming: false,
                    timestamp: dataFixa.format(),
                    protocol: chatQueue.protocol,
                    messageId: messageId
                };
                if (email !== undefined) {
                    message.email = email;
                }
                ////console.log('chathistory', message)
                return ChatService.AddToChatHistory(message).then(response => {
                    getChatMessages().then(() => {
                        scrollToBottom();
                    });
                }).catch(error => {
                    console.debug(error);
                });
            }
        }

        function clearTransferir() {
            campanhaSelected.value = "";
            campanhaTransfSelected.value = "";
            agenteSelected.value = 0;
            dataAgendamentoTicket.value = "";
            motivoSelected.value = null;
        }

        async function transferir() {
            var chats = selectedChatQueue.value
            let agentId = this.listAgentes.find(x => x.id == agenteSelected.value)

            if (agentId != null) {
                var chatsAtivos = await ChatService.chatQueueActive(agentId.id)
                let agenteNome = agenteSelected.value != null ? this.listAgentes.find(x => x.id == agenteSelected.value).nome : null
                if (agentId.interacoesSimultaneas == 0 || (agentId.interacoesSimultaneas > 0 && chatsAtivos.data.length < agentId.interacoesSimultaneas)) {
                    if ((selectedChatQueue.value.channel != constants.TipoCanal.indexOf("FACILITA_FLOW") && !campanhaSelected.value) ||
                        (selectedChatQueue.value.channel == constants.TipoCanal.indexOf("FACILITA_FLOW") && !campanhaSelected.value &&
                            !dataAgendamentoTicket.value)) {
                        toast.warning(tm('erroTransferir01'));
                    } else {
                        if (selectedChatQueue.value.channel == constants.TipoCanal.indexOf("FACILITA_FLOW")) {
                            if (!campanhaSelected.value && !dataAgendamentoTicket.value) {
                                toast.warning(tm('erroTransferir02'));
                            } else {
                                nextAction.value = "";
                                if (dataAgendamentoTicket.value) {
                                    if (agenteSelected.value && agenteSelected.value != 0) {
                                        //console.debug("data e agente");
                                        nextAction.value = "both;u;" + agenteSelected.value + ";" + dataAgendamentoTicket.value;
                                    } else if (campanhaSelected.value) {
                                        //console.debug("data e campanha");
                                        nextAction.value = "both;q;" + campanhaSelected.value + ";" + dataAgendamentoTicket.value;
                                    } else {
                                        //console.debug("somente data ");
                                        nextAction.value = "schedule;" + dataAgendamentoTicket.value;
                                    }
                                } else {
                                    if (agenteSelected.value) {
                                        //console.debug("somente agente");
                                        nextAction.value = "transfer;u;" + agenteSelected.value;
                                    } else {
                                        //console.debug("somente campanha");
                                        nextAction.value = "schedule;q;" + campanhaSelected.value;
                                    }
                                }
                                //console.debug(nextAction.value);
                                //console.debug("todo  agendar ticket")
                                $(this.$refs.modalTransferir).modal('toggle');
                            }
                        } else {
                            if (selectedChatQueue.value.channel != constants.TipoCanal.indexOf("DESCONHECIDO")) {
                                if (listMotivoTransf.value.length > 0 && !motivoSelected.value) {
                                    toast.warning(tm('erroTransferir03'));
                                } else {
                                    try {
                                        let param = {
                                            UUID: selectedChatQueue.value.uuid,
                                            campaign: campanhaSelected.value,
                                            agentId: agenteSelected.value != null ? agenteSelected.value : ""
                                        }
                                        if (!!motivoSelected.value) {
                                            let arr = {
                                                id: motivoSelected.value.id,
                                                motivo: motivoSelected.value.nome
                                            }
                                            param.userExecutation = store.state.usuario.id
                                            const resp = await ChatService.TransferChatMotivo(arr, param)
                                        } else {
                                            const resp = await ChatService.TransferChat(param)
                                        }
                                        store.dispatch('ath/clearCountProduct', selectedChatQueue.value.chatId);
                                        store.dispatch('clearMsgAlarme', selectedChatQueue.value.chatId);
                                        let chatId = selectedChatQueue.value.chatId;
                                        await getChats();
                                        if (tagsAvailable.value) {
                                            autocompleteItems.value = []
                                            autocompleteTag.value = ""
                                            autocompleteTags.value = []
                                        }
                                        store.dispatch('clearIsNew', chatId);
                                        store.commit('setChatBody', null);
                                        store.commit('setHubConnection', null);
                                        store.commit('setChatMessages', []);
                                        store.commit('setChatMessagesOld', []);
                                        toast.info(tm('sucessoTransferir'));
                                    } catch (e) {
                                        toast.warning(tm('erroTransferir04'));
                                    }
                                    $(this.$refs.modalTransferir).modal('toggle');
                                    
                                    let campDestino = listCampanhasAtivas.value.find(q => q.nome == campanhaSelected.value)
                                    
                                    await enviarMensagemInicial(chats, agenteNome, campDestino)
                                    console.log(">>>>>>>> vai executar o enviarMensagemDeTransferencia")
                                    await enviarMensagemDeTransferencia(chats, campDestino);

                                    // let conf = findConfiguracao("mensagem.conexao");

                                    // let campanhaMsg = store.state.minhasCampanhas.find(x => x.Nome == campanhaSelected.value)
                                    // let configMsgwithEmpresaCampanha = findConfiguracao("mensagem.conexao.campanha",campanhaMsg.empresaId, campanhaMsg.id);

                                    // let showMessageInicial = configMsgwithEmpresaCampanha == null || configMsgwithEmpresaCampanha.length == 0 ? true: configMsgwithEmpresaCampanha[0].valor.toLowerCase() == "true";

                                    // if (conf.length > 0 && showMessageInicial) {

                                    //     let mensagemInicial = conf[0].valor.trim().replace("{0}", agenteNome);
                                    //     console.log("Você não tem a config configMsgwithEmpresaCampanha")
                                    //     await sendMessageChatId(chats, mensagemInicial)
                                    // }
                                }
                            } else {
                                //console.debug("Codigo do canal eh zero!");
                                toast.warning(tm('erroTransferir04'));
                                $(this.$refs.modalTransferir).modal('toggle');
                            }
                        }
                    }
                } else {
                    toast.warning(tm('erroTransferir04'));
                }
            } else {
                if (selectedChatQueue.value.channel != constants.TipoCanal.indexOf("DESCONHECIDO")) {
                    if (listMotivoTransf.value.length > 0 && !motivoSelected.value) {
                        toast.warning(tm('erroTransferir03'));
                    } else {
                        try {
                            console.log(">>>>>>>> campanhaSelected.value: ", campanhaSelected.value)
                            if(campanhaSelected.value == null || campanhaSelected.value == undefined || campanhaSelected.value == ""){
                                console.log("Campanha nao selecionada")
                                toast.warning(tm('erroTransferir04'));
                            }else{

                                let param = {
                                    UUID: selectedChatQueue.value.uuid,
                                    campaign: campanhaSelected.value,
                                    agentId: agenteSelected.value != null ? agenteSelected.value : ""
                                }
                                if (!!motivoSelected.value) {
                                    let arr = {
                                        id: motivoSelected.value.id,
                                        motivo: motivoSelected.value.nome
                                    }
                                    param.userExecutation = store.state.usuario.id
                                    const resp = await ChatService.TransferChatMotivo(arr, param)
                                } else {
                                    const resp = await ChatService.TransferChat(param)
                                }
                                store.dispatch('ath/clearCountProduct', selectedChatQueue.value.chatId);
                                store.dispatch('clearMsgAlarme', selectedChatQueue.value.chatId);
                                let chatId = selectedChatQueue.value.chatId;
                                await getChats();
                                if (tagsAvailable.value) {
                                    autocompleteItems.value = []
                                    autocompleteTag.value = ""
                                    autocompleteTags.value = []
                                }
                                store.dispatch('clearIsNew', chatId);
                                store.commit('setChatBody', null);
                                store.commit('setHubConnection', null);
                                store.commit('setChatMessages', []);
                                store.commit('setChatMessagesOld', []);
                                toast.info(tm('sucessoTransferir'));
                            }
                        } catch (e) {
                            toast.warning(tm('erroTransferir04'));
                        }
                        $(this.$refs.modalTransferir).modal('toggle');
                    }
                } else {
                    //console.debug("Codigo do canal eh zero!");
                    toast.warning(tm('erroTransferir04'));
                    $(this.$refs.modalTransferir).modal('toggle');
                }
            }
        }

        function carregarTabulacoes() {
            listTabulacoes.value = [];
            listTabulacoes2.value = [];
            tabulacaoSelected.value = 0;
            tabulacaoSelected2.value = 0;

            TabulacaoService.GetTabulacoesByCampanhaAndEmpresa(selectedChatQueue.value.queueId, store.state.usuario.empresaId, 1)
                .then(response => {
                    listTabulacoes.value = response.data
                }).catch(error => {
                    console.debug(error)
                });
        }

        function clearMsgRapida() {
            topicoSelected.value = 0;
            msgRapidaSelected.value = "";

        }

        function enviarMsgRapida() {
            message.value = msgRapidaSelected.value;
        }

        function campanhaAtendimento(campanha) {
            campanhaSelecionada.value = campanha;
        }

        function puxarAtendimento() {
            let nome = undefined;
            console.log("puxarAtendimento");
            if (store.state.chatsTableData.length < refAtendimento.value) {
                if (campanhaSelecionada.value) {
                    nome = campanhaSelecionada.value.nome
                } else {
                    let item = undefined;
                    do {
                        let items = store.state.minhasCampanhas.filter(x => x.fila > 0);
                        item = items[Math.floor(Math.random() * items.length)];
                    } while (item && item.fila <= 0)
                    nome = item.nome
                }

                let statusAtual = listStatus.value.find(x => x.id == store.state.usuario.statusId);
                console.log("nome: ", nome);
                console.log("status pausa: ", statusAtual.isPausa);
                if (nome && (!statusAtual.isPausa)) {
                   
                    ChatService.GetNextChatByCampaign(store.state.usuario.id, nome)
                        .then((response) => {
                            enviarMensagemInicial(response.data)
                            getChats();
                        });
                }
            } else {
                alert("NÃO FOI POSSÍVEL RECEBER NOVO ATENDIMENTO!")
            }
        }

        function toggleATHBar() {
            toggleAppbarMobile.value = !toggleAppbarMobile.value;
        }

        function isNewMessage(chatId) {
            let isNew = localStorage.getItem('isNew') ? JSON.parse(localStorage.getItem("isNew")) : []
            favicon(isNew);
            if (store.state.chatsTableData && store.state.chatsTableData.length > 0) {
                if (isNewAtendimento(chatId)) {
                    return true
                }
                const array = store.state.chatsTableData;

                for (let i = 0; i < array.length; i++) {

                    if (array[i].chatId === chatId) {

                        let item = filaNovaMensagem.value.find(element => element.chatId === array[i].chatId)
                        const ind = filaNovaMensagem.value.findIndex(element => element.chatId === array[i].chatId)
                        if (!item) {
                            filaNovaMensagem.value.push({
                                chatId: array[i].chatId,
                                lastMessage: array[i].lastMessage
                            });

                        } else {

                            if (item.lastMessage !== array[i].lastMessage) {
                                //  let msgNew = store.state.messages.find(x => x.timestamp === item.lastMessage)

                                filaNovaMensagem.value.splice(ind, 1);
                                filaNovaMensagem.value.push({
                                    chatId: array[i].chatId,
                                    lastMessage: array[i].lastMessage
                                });
                                item = filaNovaMensagem.value.find(element => element.chatId === array[i].chatId)
                            }
                            if (store.state.messages) {
                                let msg = store.state.messages.find(x => x.timestamp === item.lastMessage)

                                if (store.state.selectedChatQueue && chatId === store.state.selectedChatQueue.chatId) {

                                    if (msg && !msg.incoming) {


                                        if (timeoutLastMessage.value.lenght > 0) {
                                            timeoutLastMessage[array[i].chatId]["flag"] = true;
                                        }
                                        let itemLast = lastNotifications.value.find(element => element.chatId === array[i].chatId &&
                                            element.lastMessage === array[i].lastMessage)
                                        if (!itemLast) {
                                            filaNovaMensagem.value.splice(ind, 1);
                                            qtdNewMsg.value[chatId] = 0;

                                            lastNotifications.value.push({
                                                chatId: array[i].chatId,
                                                lastMessage: array[i].lastMessage
                                            });
                                        }

                                        return false;
                                    }
                                    else if (msg && msg.incoming) {


                                        let itemLast = lastNotifications.value.find(element => element.chatId === array[i].chatId &&
                                            element.lastMessage === array[i].lastMessage)
                                        if (!itemLast) {
                                            notifyMe();

                                            avisoAgente(array[i].chatId, true);
                                            if (!qtdNewMsg.value[chatId]) {
                                            qtdNewMsg.value[chatId] = 1
                                            } else {
                                            qtdNewMsg.value[chatId] = qtdNewMsg.value[chatId] + 1;
                                            }
                                            lastNotifications.value.push({
                                                chatId: array[i].chatId,
                                                lastMessage: array[i].lastMessage
                                            });
                                        }



                                    }
                                }
                                else {
                                    let itemLast = lastNotifications.value.find(element => element.chatId === array[i].chatId &&
                                        element.lastMessage === array[i].lastMessage)
                                    if (!itemLast) {
                                        notifyMe();

                                        avisoAgente(array[i].chatId, true);
                                        if (!qtdNewMsg.value[chatId]) {
                                        qtdNewMsg.value[chatId] = 1
                                        } else {
                                        qtdNewMsg.value[chatId] = qtdNewMsg.value[chatId] + 1;
                                        }
                                        lastNotifications.value.push({
                                            chatId: array[i].chatId,
                                            lastMessage: array[i].lastMessage
                                        });
                                    }

                                }


                            }

                            if (store.state.selectedChatQueue && chatId === store.state.selectedChatQueue.chatId) {
                                let offset =Math.ceil (($(document.getElementById('messageBody'))[0].offsetHeight + document.getElementById('messageBody').scrollTop));
                                let scrollHeight = Math.ceil(($(document.getElementById('messageBody'))[0].scrollHeight));

                                if (offset >= scrollHeight) {
                                    if (qtdNewMsg.value[chatId] > 0 && showBotaoRolagem.value == true) {
                                        scrollToBottomSelected();
                                    }
                                } else {
                                    displayBotaoRolagem(true);
                                }
                            }
                            if (!qtdNewMsg.value[chatId] || qtdNewMsg.value[chatId] === 0) {
                            return false;
                            }
                            else {
                            return true;
                            }
                        }
                    }

                }
            }
            return false;
        };

        function tempoAtendimento(inicioAtendimento, finalAtendimento) {

            try {
                const diffInMs = Math.abs(finalAtendimento - inicioAtendimento);
                return parseInt(diffInMs / 1000);

            } catch (e) {
                console.error(e);
                return 0;
            }
        }
        async function avisoAgente(chat, flag) {
            const array = store.state.chatsTableData;
            for (let i = 0; i < array.length; i++) {
                if (array[i].chatId === chat.chatId) //store.state.selectedChatQueue == undefined ||&& (chat.chatId != store.state.selectedChatQueue.chatId)
                {

                    let item = filaNovaMensagem.value.find(element => element.chatId === array[i].chatId)
                    if (item != undefined) {
                        let dur, timeoutAlarmAgente;
                        // if (chat.queueId != undefined) {

                        //     campanha.value = listCampanhasAtivas.value.find(x => x.nome == chat.queueId);
                        // }
                        // let campanha = listCampanhasAtivas.value.find(x => x.nome == chat.queueId);

                        let chatCampanha = { id: null }
                        if (chat.queueId != undefined) {
                            chatCampanha = store.state.minhasCampanhas.find(x => x.nome == chat.queueId);
                        }
                        if (chatCampanha && chatCampanha.id ) {
                          timeoutAlarmAgente = parseInt(await getTimeoutAtendimentoAgente(chatCampanha.id));
                          let now = moment();
                          msgAlarmeAgente.value = await getTimeoutAtendimentoMsgAgente(chatCampanha.id);
                          msgAlarmeCliente.value = await getTimeoutAtendimentoMsgParaCliente(chatCampanha.id);


                          if (listAgentMsg.value != undefined && chat.chatUUID != undefined) {

                              agentAlertados.value = listAgentMsg.value.find(x => x.chat.chatUUID == chat.chatUUID);

                              if (flag) {
                                  dur = moment.duration(now.diff(moment())).as('seconds');
                                  agentAlertados.value.tempo = timeoutAlarmAgente;
                                  flagAtendimento.value = false;
                              } else {
                                  dur = moment.duration(now.diff(moment(chat.lastMessage))).as('seconds');
                              }
                          }

                        //let timeoutAlarmAgente = parseInt("30");
                        //msgAlarmeAgente.value = "Ola mensagem";
                        let listNumeros = document.getElementsByClassName('contacts-item');
                          if (timeoutAlarmAgente != 0 && dur >= timeoutAlarmAgente && agentAlertados.value == undefined) {
                              listAgentMsg.value.push({ chat: chat, tempo: timeoutAlarmAgente });
                              for (let i of listNumeros) {
                                  let numero = i.firstChild.children[1].children[0].firstChild.innerHTML;
                                  numero = numero.match(/\d+/g).join('');
                                  if (numero == chat.chatId) { //&& selectedChatQueue.value == undefined
                                      //i.firstChild.setAttribute("style", "background-color: #FCE4D6;");
                                      await sendMessageChatId(chat, msgAlarmeCliente.value)
                                      notifyMeAgent(msgAlarmeAgente.value);
                                  } else {
                                      if (numero == chat.chatId) { // && selectedChatQueue.value.chatId != numero
                                          //i.firstChild.setAttribute("style", "background-color: #FCE4D6;");
                                          await sendMessageChatId(chat, msgAlarmeCliente.value)
                                          notifyMeAgent(msgAlarmeAgente.value);
                                      }
                                  }
                              }
                          } else if (timeoutAlarmAgente != 0 && agentAlertados.value != undefined && flagAtendimento.value == false) {
                              if (dur >= agentAlertados.value.tempo) {
                                  agentAlertados.value.tempo = agentAlertados.value.tempo + timeoutAlarmAgente;
                                  //await sendMessageChatId(chat, msgAlarmeCliente.value)
                                  notifyMeAgent(msgAlarmeAgente.value);
                              }
                          }
                        }
                    }
                }
            }


        }

        async function finalizarAtendimento(chatSelecionado) {
            let chat = (typeof chatSelecionado === 'undefined') ? selectedChatQueue.value : chatSelecionado;
            let chatId = chat.chatId;
            let tab = {};
            let hasError = false;
            if (tabulacaoSelected.value !== 0) {
                let tabTemp = listTabulacoes.value.find(x => x.id == tabulacaoSelected.value);
                tab = {
                    id: tabTemp.id,
                    nome: tabTemp.nome
                };
            }
            if (tabulacaoSelected2.value !== 0) {
                let tabTemp2 = listTabulacoes2.value.find(x => x.id == tabulacaoSelected2.value);
                tab = {
                    id: tabTemp2.id,
                    nome: tabTemp2.nome
                };
            }
            if (Object.keys(tab).length == 0) {
                tab = {
                    id: -1,
                    nome: tm('finalizadoSemTab')
                };
            }

            let chatCampanha = { id: undefined }
            if (chat.queueId != undefined) {
                chatCampanha = store.state.minhasCampanhas.find(x => x.nome == chat.queueId);
            }

            try {

                // const posLast = lastNotifications.value.map(function (e) {
                //     return e.chatId;
                // }).indexOf(chats.chatId);
                // if (posLast != -1) {
                //     lastNotifications.value = lastNotifications.value.filter(notification => notification.chatId !== chats.chatId);
                //     //lastNotifications.value.splice(posLast, 1);
                // }
                lastNotifications.value = lastNotifications.value.filter(notification => notification.chatId != chatId);

                const response = await ChatService.FinishItemWithTab(chat.uuid, tab);
                // sendMsgChat("Atendimento finalizado. Obrigado pelo contato!");
                if (200 === response.status) {


                    // let msgFinalizacao = findConfiguracao("mensagem.fim.atendimento", chat.empresaId, campanha.id);
                    let msgFinalizacao = findConfiguracao("mensagem.fim.atendimento", chat.empresaId, chatCampanha.id);
                    if (msgFinalizacao.length > 0 && chat.channel != constants.TipoCanal.indexOf("EMAIL") &&
                        !isMarketplace(chat.channel)) {
                        //message.value = msgFinalizacao[0].valor
                        await sendMessageChatId(chat, msgFinalizacao[0].valor, true, tab.nome)
                    }
                    if (chat.channel == constants.TipoCanal.indexOf("WEBCHAT")) {
                        //message.value = "{END}{END}{END}";
                        await sendMessageChatId(chat, "{END}{END}{END}", true, tab.nome)
                    }
                    if (atendimentoPorIndicadores.value) {
                        let tempoAtendimentoIndicadores = tempoAtendimento(new Date(chat.dateStarted).getTime(), new Date().getTime());
                        let campanha = listCampanhasAtivas.value.find(x => x.nome == chat.queueId);
                        await ChatService.IndicadoresFimAtendimento(store.state.usuario.id, store.state.usuario.empresaId, campanha.id, tempoAtendimentoIndicadores);
                    }
                }
                let index = objFimAtendimento.value.map(x => x.numID).indexOf(chat.chatId)
                if (index != -1) {
                    objFimAtendimento.value.splice(index, 1);
                }
                store.dispatch('ath/clearCountProduct', chat.chatId);
                store.dispatch('clearMsgAlarme', chat.chatId);
            } catch (error) {
                console.debug(error);
                hasError = true;
            } finally {
                if (listAgentMsg.value != undefined) {
                    listAgentMsg.value = listAgentMsg.value.filter(x => x.chat.chatUUID != chat.chatUUID);
                }
                await getChats()
                if (tagsAvailable.value) {
                    autocompleteItems.value = []
                    autocompleteTag.value = ""
                    autocompleteTags.value = []
                }
                store.dispatch("ath/clearCompra", chatId);
                store.dispatch('clearIsNew', chatId);
                setMainTab(false);
                store.commit('setChatMessages', []);
                store.commit('setChatMessagesOld', []);
                store.commit('setChatBody', null);
                if (hasError) {
                    toast.warning(tm('erroFinalizar'));
                } else {
                    toast.info(tm('atendimentoFinalizado'));
                }
            };
        };

        function setMessage(val) {
            message.value = val;
            showInstanMessages.value = false;
        };

        function exibeInstantMessages(event) {
            if (event) {
                showInstanMessages.value = instantMessages.value.length > 0;
            }
        };

        function appendEmoji(emoji) {
            message.value = message.value + emoji;
        }

        function escreverEmail() {
            message.value = `<style type="stylesheet">body{background-image: linear-gradient(19deg, #21D4FD 0%, #B721FF 100%);ccc; background-repeat: no-repeat;font: 400 16px/1.5em "Open Sans", sans-serif;}.page-content{max-width: 700px; margin: 32px auto; padding: 32px; background: #fff;}a{color: #21D4FD; transition: all 0.3s;}a:hover{color: #B721FF;}.tabbed{overflow-x: hidden; /* so we could easily hide the radio inputs */margin: 32px 0;padding-bottom: 16px;border-bottom: 1px solid #ccc;}.tabbed [type="radio"]{/* hiding the inputs */display: none;}.tabs{display: flex;align-items: stretch;list-style: none;padding: 0;border-bottom: 1px solid #ccc;}.tab > label{display: block;margin-bottom: -1px;padding: 12px 15px;border: 1px solid #ccc;background: #eee;color: #666;font-size: 12px; font-weight: 600;text-transform: uppercase;letter-spacing: 1px;cursor: pointer;transition: all 0.3s;}.tab:hover label{border-top-color: #333;color: #333;}.tab-content{display: none;color: #777;}/* As we cannot replace the numbers with variables or calls to element properties, the number of this selector parts is our tab count limit */.tabbed [type="radio"]:nth-of-type(1):checked ~ .tabs .tab:nth-of-type(1) label,.tabbed [type="radio"]:nth-of-type(2):checked ~ .tabs .tab:nth-of-type(2) label,.tabbed [type="radio"]:nth-of-type(3):checked ~ .tabs .tab:nth-of-type(3) label,.tabbed [type="radio"]:nth-of-type(4):checked ~ .tabs .tab:nth-of-type(4) label,.tabbed [type="radio"]:nth-of-type(5):checked ~ .tabs .tab:nth-of-type(5) label{border-bottom-color: #fff;border-top-color: #B721FF;background: #fff;color: #222;}.tabbed [type="radio"]:nth-of-type(1):checked ~ .tab-content:nth-of-type(1),.tabbed [type="radio"]:nth-of-type(2):checked ~ .tab-content:nth-of-type(2),.tabbed [type="radio"]:nth-of-type(3):checked ~ .tab-content:nth-of-type(3),.tabbed [type="radio"]:nth-of-type(4):checked ~ .tab-content:nth-of-type(4){display: block;}</style><div class="page-content"><p>This is my solution for css-only tabs. It's not perfect, but has some advantages, like some degree of flexibility - the CSS is id-agnostic, so the HTML can be generated by server-side scripts (for example in WordPress shortcodes).</p><p>All you need to generate are the radio buttons' ids and names.</p><div class="tabbed"><input type="radio" id="tab1" name="css-tabs" checked><input type="radio" id="tab2" name="css-tabs"><input type="radio" id="tab3" name="css-tabs"><ul class="tabs"><li class="tab"><label for="tab1">Gangsta lipsum</label></li><li class="tab"><label for="tab2">Zombie lipsum</label></li><li class="tab"><label for="tab3">New age bullshit</label></li></ul><div class="tab-content"><h4>Gangsta lipsum</h4><p>Da bomb ipsizzle dolizzle sit amizzle, consectetuer adipiscing fo shizzle. Nullam yo velizzle, aliquet volutpizzle, fo shizzle yippiyo, for sure vizzle, arcu. Black eget fo shizzle. Sizzle erizzle. Rizzle at dolizzle dapibizzle turpis tempizzle izzle. Maurizzle crackalackin nibh et check out this. Cool check it out tortizzle. Break it down bling bling rhoncizzle my shizz. Fo hizzle rizzle platea boom shackalack. Gangsta dapibus. Owned tellus urna, pretizzle black, mattizzle ac, eleifend for sure, nunc. Owned suscipizzle. Integizzle sempizzle shiz sed purizzle.</p></div><div class="tab-content"><h4>Zombie lipsum</h4><p>Zombie ipsum brains reversus ab cerebellum viral inferno, brein nam rick mend grimes malum cerveau cerebro. De carne cerebro lumbering animata cervello corpora quaeritis. Summus thalamus brains sit​​, morbo basal ganglia vel maleficia? De braaaiiiins apocalypsi gorger omero prefrontal cortex undead survivor fornix dictum mauris. </p></div><div class="tab-content"><h4>New age bullshit</h4><p>Our conversations with other pilgrims have led to an awakening of pseudo-astral consciousness. Who are we? Where on the great myth will we be re-energized? We are at a crossroads of complexity and stagnation.</p><p>Eons from now, we dreamers will exist like never before as we are aligned by the cosmos. We are being called to explore the stratosphere itself as an interface between nature and complexity. We must learn how to lead infinite lives in the face of bondage.</p><p>Generated by the <a href="http://sebpearce.com/bullshit/">New Age Bullshit Generator</a></p></div></div><p>The tabs are quite easy to use as they don't need absolute positioning and min-heights.</p><p>They can also be used multiple times in one document without any influence on CSS.</p><div class="tabbed"><input type="radio" id="tab21" name="css-tabs2" checked><input type="radio" id="tab22" name="css-tabs2"><input type="radio" id="tab23" name="css-tabs2"><ul class="tabs"><li class="tab"><label for="tab21">Gangsta lipsum</label></li><li class="tab"><label for="tab22">Zombie lipsum</label></li><li class="tab"><label for="tab23">New age bullshit</label></li></ul><div class="tab-content"><h4>Gangsta lipsum</h4><p>Da bomb ipsizzle dolizzle sit amizzle, consectetuer adipiscing fo shizzle. Nullam yo velizzle, aliquet volutpizzle, fo shizzle yippiyo, for sure vizzle, arcu. Black eget fo shizzle. Sizzle erizzle. Rizzle at dolizzle dapibizzle turpis tempizzle izzle. Maurizzle crackalackin nibh et check out this. Cool check it out tortizzle. Break it down bling bling rhoncizzle my shizz. Fo hizzle rizzle platea boom shackalack. Gangsta dapibus. Owned tellus urna, pretizzle black, mattizzle ac, eleifend for sure, nunc. Owned suscipizzle. Integizzle sempizzle shiz sed purizzle.</p></div><div class="tab-content"><h4>Zombie lipsum</h4><p>Zombie ipsum brains reversus ab cerebellum viral inferno, brein nam rick mend grimes malum cerveau cerebro. De carne cerebro lumbering animata cervello corpora quaeritis. Summus thalamus brains sit​​, morbo basal ganglia vel maleficia? De braaaiiiins apocalypsi gorger omero prefrontal cortex undead survivor fornix dictum mauris. </p></div><div class="tab-content"><h4>New age bullshit</h4><p>Our conversations with other pilgrims have led to an awakening of pseudo-astral consciousness. Who are we? Where on the great myth will we be re-energized? We are at a crossroads of complexity and stagnation.</p><p>Eons from now, we dreamers will exist like never before as we are aligned by the cosmos. We are being called to explore the stratosphere itself as an interface between nature and complexity. We must learn how to lead infinite lives in the face of bondage.</p><p>Generated by the <a href="http://sebpearce.com/bullshit/">New Age Bullshit Generator</a></p></div></div><p>Unfortunately, these tabs have one downside: limited tab count. The limit is set in the CSS (see comments in the CSS code). But let's get real: who uses lots of tabs?</p><p>And one more thing: no animation to prevent annoying page jumps.</p><p>Have an improvement idea? Feel free to suggest it in the comments!</p></div>`;
        }

        function notifyMe() {
            if (Notification.permission !== 'granted') {
                Notification.requestPermission();
            } else {
                if (!document.hasFocus()) {
                    let notificacaoBody = {
                        body: tm('novaMsg'),
                        silent: false
                    }

                    let title = process.env.VUE_APP_NOTIFICACAOTITLE || "Interage"
                    let showFavicon = process.env.VUE_APP_SHOWNOTIFICACAOICON || 1

                    if (showFavicon == 1) {
                        notificacaoBody.icon =window.location.origin + '/favicon.ico'
                    }

                    var notification = new Notification(title, notificacaoBody);

                    notification.onclick = function () {
                        window.focus();
                        window.blur();
                        this.close();
                    };
                }
            }
        };

        function notifyMeAgent(msgAlarmeAgente) {
            debugger
            if (Notification.permission !== 'granted') {
                Notification.requestPermission();
            } else {
                if (!document.hasFocus()) {

                    let notificacaoBody = {
                        body: msgAlarmeAgente,
                        silent: false
                    }
                    let title = process.env.VUE_APP_NOTIFICACAOTITLE || "Interage"
                    let showFavicon = process.env.VUE_APP_SHOWNOTIFICACAOICON || 1

                    if (showFavicon == 1) {
                        notificacaoBody.icon =window.location.origin + '/favicon.ico'
                    }

                    var notification = new Notification(title, notificacaoBody);

                    notification.onclick = function () {
                        window.focus();
                        window.blur();
                        this.close();
                    };
                }
            }
        };

        function exportarChat() {
            toast.info(tm('msgExportar01'));
            content.splice(0, content.length);
            html2canvas(document.querySelector("#messageday"))
                .then(canvas => {
                    /* Geranddo PDF */
                    var data = canvas.toDataURL();
                    const {
                        width,
                        height
                    } = getPngDimensions(canvas.toDataURL());
                    const printHeight = height * constants.PAGE_WIDTH / width;
                    if (printHeight > constants.PAGE_HEIGHT) {
                        const img = new Image();
                        img.src = data;
                        img.onload = splitImage(img, downloadPdf);
                        return;
                    }
                    content.push({
                        image: data,
                        margin: [0, 5],
                        width: constants.PAGE_WIDTH
                    });
                    downloadPdf();

                    /* Gerando IMAGEM*/
                    // let contextoGrafico = canvas.getContext('2d');
                    // contextoGrafico.webkitImageSmoothingEnabled = false;
                    // contextoGrafico.mozImageSmoothingEnabled = false;
                    // contextoGrafico.imageSmoothingEnabled = false;
                    // let imagemCodificadaEmURL = canvas.toDataURL();
                    // let link = document.createElement('a');
                    // let nome = (selectedChatQueue.value.contactName ? selectedChatQueue.value.contactName + " (" +selectedChatQueue.value.chatId + ")" : selectedChatQueue.value.chatId)
                    // link.download = nome + ' - ' + new Date().toLocaleString('pt-br') + '.png';
                    // link.href = imagemCodificadaEmURL;
                    // document.body.appendChild(link);
                    // link.click();


                }).catch((e) => {
                    console.debug(e)
                    toast.error(tm('erroExportar'));
                });
        };

        function getPngDimensions(base64) {
            const header = atob(base64.slice(22, 70)).slice(16, 24);
            const uint8 = Uint8Array.from(header, c => c.charCodeAt(0));
            const dataView = new DataView(uint8.buffer);
            return {
                width: dataView.getInt32(0),
                height: dataView.getInt32(4)
            };
        }

        const splitImage = (img, callback) => () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const printHeight = img.height * constants.PAGE_WIDTH / img.width;
            canvas.width = constants.PAGE_WIDTH;
            for (let pages = 0; printHeight > pages * constants.PAGE_HEIGHT; pages++) {
                canvas.height = Math.min(constants.PAGE_HEIGHT, printHeight - pages * constants.PAGE_HEIGHT);
                ctx.drawImage(img, 0, -pages * constants.PAGE_HEIGHT, canvas.width, printHeight);
                content.push({
                    image: canvas.toDataURL(),
                    margin: [0, 5],
                    width: constants.PAGE_WIDTH
                });
            }
            callback();
        };

        function downloadPdf() {
            var docDefinition = {
                content: content
            };
            try {
                let nome = (selectedChatQueue.value.contactName ? selectedChatQueue.value.contactName + " (" + selectedChatQueue.value.chatId + ")" : selectedChatQueue.value.chatId) +
                    ' _ ' + new Date().toLocaleString('pt-br') + '.pdf'
                pdfMake.createPdf(docDefinition).download(nome);
                toast.clear();
                toast.success(tm('msgExportar02'));
            } catch (e) {
                toast.error(tm('erroExportar'));
            }
        };

        async function puxarNexAtendimento(qtdEmAtendimento) {
        //function puxarNexAtendimento(qtdEmAtendimento) {
            isLoadingAtendimento.value = true
            var arr = store.state.minhasCampanhas.map(function (e) {
                return e.nome;
            });
            try {
                if (qtdEmAtendimento < refAtendimento.value) {
                    if (atendimentoPorIndicadores.value) {
                        const respIndicadores = await ChatService.nextIndicadores(arr, store.state.usuario.id, store.state.usuario.empresaId); //await ChatService.nextIndicadores(arr, store.state.usuario.id, store.state.usuario.empresaId);
                        console.log("puxarNexAtendimento");
                        console.log(respIndicadores)
                        for (var i = 0; i < respIndicadores.data.length; i++) {
                            //await enviarMensagemInicial(respIndicadores.data[i]);
                            enviarMensagemInicial(respIndicadores.data[i]);
                        }
                    } else {
                        const response = await ChatService.GetChatsNext(arr, store.state.usuario.id) //await ChatService.GetChatsNext(arr, store.state.usuario.id)
                        console.log("puxarNexAtendimento-----GetChatsNext");
                        //console.log(response)
                        //await enviarMensagemInicial(response.data)
                        enviarMensagemInicial(response.data)
                    }
                    //await getChats();
                    //getChats();
                    isLoadingAtendimento.value = false
                } else {
                    alert("NÃO FOI POSSÍVEL RECEBER NOVO ATENDIMENTO!")
                }
            } catch (e) {
                isLoadingAtendimento.value = false
            }
        }

        //async
        const getListStatus = async () => {
            if (!store.state.listStatus || store.state.listStatus.length === 0) {
                await store.dispatch("getListStatus")
            }
        }

        const getMinhascampanhas = async () => {
            await store.dispatch('getMinhasCampanhas');
            campanhasFilter.value = store.state.minhasCampanhas;
        }

        const getListHsm = async () => {
            listHSM.value = [];
            try {
                const response = await ListService.getMensagensSalvasFilter(store.state.usuario.id);
                listHSM.value = response.data;
            } catch (error) {
                console.debug(error);
            }
        }

        const getMinhasAgendas = async () => {
            await store.dispatch('getMinhasAgendas');
        }

        const getChats = async () => {

            await store.dispatch('getChats', {
                cliente: clienteAvailable.value,
                agent: true
            });
        }

        const getChatMessages = async () => {
            await store.dispatch('getChatMessages');
            if (store.state.selectedChatQueue &&
                store.state.selectedChatQueue.channel === constants.TipoCanal.indexOf("EMAIL") &&
                !document.querySelector('.ck-editor')) {
                //buildCKEditor();
            }
        }

        const scrollToBottom = async () => {
            document.getElementById('messageBody').scrollTop = document.getElementById('messageBody').scrollHeight;
            displayBotaoRolagem(false);
        }

        function scrollToBottomSelected() {
            if (store.state.selectedChatQueue) {
                let pos = filaNovaMensagem.value.map(function (e) {
                    return e.chatId;
                }).indexOf(store.state.selectedChatQueue.chatId);
                if (pos != -1) {
                    filaNovaMensagem.value.splice(pos, 1);
                }
                let posLast = lastNotifications.value.map(function (e) {
                    return e.chatId;
                }).lastIndexOf(store.state.selectedChatQueue.chatId);
                if (posLast != -1) {
                    let lastNot = lastNotifications.value.filter(notification => notification.chatId === store.state.selectedChatQueue.chatId && lastNotifications.value.indexOf(notification) === posLast);
                    lastNotifications.value = lastNotifications.value.filter(notification => notification.chatId !== store.state.selectedChatQueue.chatId);
                    lastNotifications.value.push(lastNot[0]);
                    qtdNewMsg.value[store.state.selectedChatQueue.chatId] = 0
                    //lastNotifications.value.splice(posLast, 1);
                }

            }
            scrollToBottom();
        }

        function findConfiguracao(confName, empresaId, campanhaId) {
           // console.log("FindConfiguracao: ", store.state.listConfiguracoes);
            if (!confName)
                return undefined;
            else {
                let reg = store.state.listConfiguracoes.filter(y => y.chave == confName && y.empresaId == undefined && y.campanhaId == undefined && y.padrao);
                let regT = null
                if (empresaId && campanhaId) {
                    regT = store.state.listConfiguracoes.filter(y => y.chave == confName && y.empresaId == empresaId && y.campanhaId == campanhaId)
                }
                if (!regT || regT.length == 0) {
                    regT = store.state.listConfiguracoes.filter(y => y.chave == confName && y.empresaId == empresaId && y.campanhaId == null)
                }
                if (regT && regT.length > 0)
                    reg = regT;
                return reg;
            }
        }

        const getCampanhasAtivas = async () => {
            listCampanhasAtivas.value = [];
            if (store.state.usuario.empresaId) {
                try {
                    const response = await CampanhaService.GetCampaignsActive(store.state.usuario.empresaId);
                    listCampanhasAtivas.value = response.data;


                } catch (error) {
                    console.debug(error);
                }
            }
        };
        const getTopicosMsgRapidas = async () => {
            listTopicos.value = [];
            if (store.state.usuario.empresaId) {
                try {
                    const response = await ListService.getTopicosMensagemRapida(store.state.usuario.empresaId);
                    listTopicos.value = response.data;
                } catch (error) {
                    console.debug(error);
                }
            }
        };

        const fetchFilaCampanhas = async () => {
            //Ivanildo 14.12.2021 - Alterado a busca que antes era feita de 1 em 1
            // agora fornece um array com as companhas

            // store.state.minhasCampanhas.forEach(x => {
            //   ChatService.GetChatsByCampaign(x.nome)
            //     .then((response) => {
            //       x.fila = response.data.length;
            //     })
            //     .catch((error) => {})
            // });

            try {
                let arrCampanhas = store.state.minhasCampanhas.map((camp) => {
                    return camp.nome
                });
                let response = await ChatService.GetChatsByCampaignList(arrCampanhas);
                //console.log("fetchFilaCampanhas")
                //console.log(response)
                //zerar todas as filas
                store.state.minhasCampanhas.forEach(c => {
                    c.fila = 0;
                    // carregar se a campanha retornou na chamada
                    let cp = response.data.filter(x => x.queueId.toLowerCase() == c.nome.toLowerCase());
                    if (cp.length > 0) {
                        c.fila = cp[0].lenght;
                    }
                })
            } catch (error) {
                //console.log(error)
            }

        }

        const hasFila = async () => {
            return store.state.minhasCampanhas.reduce((a, b) => a + (b['fila'] || 0), 0) > 0;
        }

        const getAllMessages = async () => {
            allMessages.value = [];
            try {
                const response = await ListService.getMensagensRapidaByEmpresa(store.state.usuario.empresaId)
                allMessages.value = response.data;
            } catch (error) {
                console.debug(error);
            }
        }

        const isScrolledToBottom = () => {
            const el = document.getElementById('messageBody');
            return el.scrollHeight - el.scrollTop - el.clientHeight < 50;
        };

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'kb', 'mb', 'gb', 'tb'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
        }

        async function enviarEmail() {
            isloadingEmail.value = true
            let chatSelecionado = selectedChatQueue.value;
            let emailResposta = {
                ...chatSelecionado.email
            };
            let campanha = store.state.minhasCampanhas.find(x => x.nome == chatSelecionado.queueId);
            let emailsResposta = findConfiguracao("atendimento.email.resposta", chatSelecionado.empresaId, campanha.id);
            let listTemp = ((remetenteAlterado.value.indexOf(chatSelecionado.chatUUID) === -1) ? [chatSelecionado.email.remetente] : [...(novoRemetenteEmail.value.map((obj) => ({
                'email': obj
            })))]);

            const emailsFiltrados = listTemp.filter((el) => {
                return emailsResposta.some((f) => {
                    return f.valor !== el;
                });
            });

            emailResposta.listaDestinatario = [];
            emailsFiltrados.forEach(x => emailResposta.listaDestinatario.push(x));

            emailResposta.remetente = {
                nome: tm('emailRemetente'),
                email: emailsResposta.pop().valor
            };
            emailResposta.corpo = message.value;

            emailResposta.listaAnexo = []
            if (emailResposta.possuiAnexo) {
                chatSelecionado.email.listaAnexo.forEach(x => emailResposta.listaAnexo.push({
                    id: x.id,
                    nome: x.nome,
                    caminhoUrl: x.caminhoUrl,
                    tamanho: x.tamanho
                }));
            }
            if (listaAnexoEmail.value.length > 0) {
                listaAnexoEmail.value.forEach(x => emailResposta.listaAnexo.push({
                    id: x.id,
                    nome: x.nome,
                    caminhoUrl: x.caminhoUrl,
                    tamanho: x.tamanho
                }));
            }
            await sendMessage(null, emailResposta)
            await getChatMessages()
            try {
                //await EmailService.SendEmail(chatSelecionado.chatUUID)
                await finalizarAtendimento(chatSelecionado);
            } catch (e) {
                console.debug(e);
                toast.warning(tm('erroEmail'));
            } finally {
                isloadingEmail.value = false
            }
        }

        function excluirAnexo(value, ind) {
            listaAnexoEmail.value.splice(ind, 1)
        }

        async function finishUserSession() {
            ////console.log("ID da Sessao do Usuario: ", store.state.usuario.sessaoUsuario[0].id);
            await UsuarioService.FinishUserSession(store.state.usuario.id, store.state.usuario.sessaoUsuario[0].id);
            localStorage.removeItem("token");
            localStorage.removeItem("usuario");
            localStorage.removeItem("senhaPadrao");
            store.dispatch('clearStore');
        };

        function loadAudio() {
            recorder.value =  new MicRecorder({  bitRate: 128 })
            // navigator.mediaDevices.getUserMedia({
            //     audio: true
            // }).then(stream => {
            //     mediaRecorder.value = new MediaRecorder(stream);
            //     recorder.value =  new MicRecorder({  bitRate: 128 })

            //     mediaRecorder.value.ondataavailable = (e) => {
            //         console.log("mediaRecorder.value.ondataavailable")
            //         chunks.value.push(e.data);
            //     };

            //     mediaRecorder.value.onstop = (e) => {
            //         console.log("mediaRecorder.value.onstop")
            //         fileAnexo.value = new Audio();
            //         let blob = new Blob(chunks.value, {
            //             'type': 'audio/ogg'
            //         });
            //         chunks.value = [];
            //         let reader = new window.FileReader();
            //         reader.readAsDataURL(blob);
            //         reader.onloadend = function () {
            //             fileAnexo.value = reader.result;
            //             sendAnexo('inputVoice');
            //         };
            //     };

            // })
            //     .catch((error) => { })
        };

        function startRecord() {
            recorder.value.start().then(() => {
                let start = new Date;
                timeRecording.value = setInterval(function () {
                    let sec = parseInt((new Date - start) / 1000);
                    let min = parseInt(sec / 60);
                    timeText.value = ((min < 10 ? '0' : '') + min) + ":" + ((sec < 10 ? '0' : '') + (sec - (60 * min)));
                }, 1000);
                isRecording.value = true;
                gravacaoPronta.value = false;
            }).catch((e) => {
                console.log("recorder.start.error=>", e);
            });
        }

        function stopRecord() {
            const estavaNoFim = isScrolledToBottom(); // <--- Salva ANTES de parar a gravação

            recorder.value.stop().getMp3().then(([buffer, blob]) => {
                clearInterval(timeRecording.value);

                displayBotaoRolagem(!estavaNoFim); // Mostra o botão se NÃO estava no fim

                let reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = function () {
                    audioGravado.value = reader.result;
                    gravacaoPronta.value = true;

                    nextTick(() => {
                        scrollToBottom(); // Força a rolagem para o fim, SEM checar nada                   
                    });
                };
                isRecording.value = false;
                timeText.value = "00:00";
            }).catch((e) => {
                console.error(e);
            });
        }

        function playAudioPreview() {
            if (audioPreview.value && typeof audioPreview.value.play === 'function') {
            audioPreview.value.play();
            } else {
            console.warn("Elemento de áudio não está disponível.");
            }
        }

        function enviarGravacao() {
            if (audioGravado.value) {
                fileAnexo.value = audioGravado.value; // apenas isso já basta
                sendAnexo('inputVoice');
                gravacaoPronta.value = false;
                audioGravado.value = null;
            }
        }

        function cancelarGravacao() {
            gravacaoPronta.value = false;
            audioGravado.value = null;
        }

        function changeRemetentePadrao() {
            let idx = remetenteAlterado.value.indexOf(selectedChatQueue.value.chatUUID);
            if (idx == -1)
                remetenteAlterado.value.push(selectedChatQueue.value.chatUUID);
            else
                remetenteAlterado.value.splice(idx, 1);
        }

        function sendCatalog(secao) {
            let queryUrl = "?l=" + store.state.ath.selectedLoja[store.state.selectedChatQueue.chatId]
            if (secao !== null && secao !== undefined)
                queryUrl += "&s=" + secao
            // let campanha = listCampanhasAtivas.value.find(x => x.nome == selectedChatQueue.value.queueId);
            let linkCatalogo = findConfiguracao("catalog.link", selectedChatQueue.value.empresaId);
            if (linkCatalogo.length > 0) {
                message.value = linkCatalogo[0].valor + queryUrl;
                sendMessage();
                toast.info(tm('msgCatalogo'));
            } else {
                toast.warning(tm('erroCatalogo'));
            }
        }

        function sendMsgChat(msg) {
            message.value = msg
            sendMessage()
        }

        function expandirColapsarAgrupamento(evento) {
            let imagem
            let elemento
            if ($(evento.target).get(0).tagName == "H6") {
                imagem = $(evento.target).find("svg")
                elemento = $(evento.target)
            } else if ($(evento.target).get(0).tagName == "svg") {
                imagem = $(evento.target)
                elemento = $(evento.target).parent()
            } else {
                imagem = $(evento.target).parent()
                elemento = $(evento.target).parent().parent()
            }
            if (!$(elemento).hasClass('collapsed')) {
                imagem.removeClass('fa-chevron-down');
                imagem.addClass('fa-chevron-right');
            } else {
                imagem.removeClass('fa-chevron-right')
                imagem.addClass('fa-chevron-down')
            }
        }

        function getIntroOptions() {
            let steps = [];

            steps.push({
                title: tm('tutorial01'),
                intro: tm('tutorial02'),
                tooltipClass: 'customIntroBox-lg'
            });
            if (!isEmbedded.value) {
                steps.push({
                    title: tm('tutorial03'),
                    intro: tm('tutorial04'),
                    element: document.querySelector('.nav.nav-minimal.flex-row > li:first-child'),
                });
                steps.push({
                    title: tm('tutorial03'),
                    intro: tm('tutorial05'),
                    element: document.querySelector('.nav.nav-minimal.flex-row > li:last-child'),
                });
            }
            steps.push({
                title: tm('tutorial06'),
                intro: tm('tutorial07'),
                element: document.querySelector('#chatContactsList > div'),
            });
            let textoFila = '';
            if (store.state.usuario) {
                let confTransf = findConfiguracao("funcao.indicador.fila", store.state.usuario.empresaId);
                if (confTransf.length > 0)
                    if ((confTransf[0].valor ? confTransf[0].valor.toLowerCase() : '') == "true") {
                        textoFila = tm('tutorial08');
                    }
            }
            if (!isHsmAvailable.value) {
                textoFila += tm('tutorial09');
            }

            steps.push({
                title: tm('tutorial06'),
                intro: tm('tutorial10') + ` ${textoFila} ` + tm('tutorial11'),
                element: document.querySelector('#chatContactsList > div > div.d-flex.justify-content-between.align-items-center'),
                tooltipClass: 'customIntroBox-lg'
            });

            let textoAplicativos = '';
            if (atendimentoAvailableTutorial.value) {
                textoAplicativos = tm('tutorial12')
            }
            if (clienteAvailable.value) {
                textoAplicativos += tm('tutorial20');
            }
            if (agendaAvailable.value) {
                textoAplicativos += tm('tutorial21');
            }

            steps.push({
                title: tm('tutorial13'),
                intro: tm('tutorial14'),
                element: document.querySelector('#chatContactTab'),
                tooltipClass: 'customIntroBox-lg'
            });

            steps.push({
                title: tm('tutorial15'),
                intro: `${textoAplicativos}` + tm('tutorial17') + (isEmbedded.value ? "" : tm('tutorial16')),
                element: document.querySelector('#appNavTab'),
                tooltipClass: 'customIntroBox-lg'
            });

            steps.push({
                title: tm('tutorial18'),
                intro: tm('tutorial19'),
            });

            return {
                showProgress: true,
                exitOnEsc: false,
                hidePrev: true,
                disableInteraction: true,
                exitOnOverlayClick: false,
                nextLabel: tm('proximo'),
                prevLabel: tm('anterior'),
                doneLabel: tm('finalizar'),
                steps: steps
            };
        }

        function loadIntroTutorial() {
            setMainTab(false);
            appBarClear();
            $('.main.main-visible').removeClass('main-visible');
            $('#quick-settings').removeClass('active');
            $('.appbar.appbar-ath').addClass('appbar-hidden');
            $('html').css('overflow', 'hidden');
            introJs()
                .setOptions(getIntroOptions())
                .onbeforechange(function (cb) {
                    if ($('#app > div > div.appbar.appbar-ath > div.appbar-wrapper.hide-scrollbar')[0]) {
                        let el = $('#appNavTab')[0];
                        if (el && cb && $(cb)[0].className === el.className) {
                            $('.appbar.appbar-ath.appbar-hidden').removeClass('appbar-hidden');
                        } else {
                            $('.appbar.appbar-ath').addClass('appbar-hidden');
                        }
                    }
                    //let el2 = $('#app > div > main > div > div > div.chat-header.position-relative > div.nav.flex-nowrap')[0];
                    //if (el2 && $(cb)[0].className === el2.className) {
                    //  $('.main').addClass('main-visible');
                    //  setMainTab(true);
                    //  showIntroRef.value = true;
                    //} else {
                    //  $('.main.main-visible').removeClass('main-visible');
                    //  setMainTab(false);
                    //  showIntroRef.value = false;
                    //}
                    introJs().refresh();
                }).oncomplete(function () {
                    localStorage.setItem('introOk', true);
                    showIntroRef.value = false;
                    $('html').css('overflow', '');
                }).start();
        }

        function buildCKEditor() {

            //console.debug(ClassicEditor.builtinPlugins.map(plugin => plugin.pluginName));

            ClassicEditor
                .create(document.querySelector('#ckeditor'), {
                    language: 'pt-br',
                    placeholder: 'Digite aqui a resposta.',
                }).then(editor => {
                    console.debug('Editor was initialized', editor);
                    console.debug(editor.plugins._availablePlugins.keys());
                    console.debug(editor.ui.componentFactory.names());
                }).catch(error => {
                    console.debug(error.stack);
                });

        }

        function displayBotaoRolagem(val) {
            showBotaoRolagem.value = val;
        }

        const getListConfiguracoes = async () => {
            await store.dispatch("getListConfiguracoes");
            await getClienteAvaliable()
            if (clienteAvailable.value) {
                await getAutocadastrozappag()
            }
            await getAgendaAvaliable()
            if (agendaAvailable.value) {
                await getMinhasAgendas();
            }
            if (isEmbedded.value) {
                getMsgRapidaAvaliable()
            } else {
                msgRapidaAvailable.value = true
            }
            await getAvisoAthFinalizadoAvaliable()
            if (avisoAthFinalizado.value) {
                loadSaidaUsuario();
            }
            await getBuscaAtendimento();
            await getBuscaAtendimentoHsm();
            await getTagsAvaliable()
            await getTagsCadastroAvaliable()
            await getAtendimentoPorIndicadores()
            //console.log('distribuidor-indicadores:', atendimentoPorIndicadores.value)
            getHistoricoAvailable()
            getHistoricoHsmAvailable();
            getMaxAtendimento()
            setChats();
            setPreAtendimento();
            var valorConfiguracao = findConfiguracao("operador.desmarcar_campanha", store.state.usuario.empresaId);
            if (valorConfiguracao.length != 0) {
                stateLocal.operadorDesmarcarCampanha = valorConfiguracao[0].valor == "true" ? true : false;
            } else {
                stateLocal.operadorDesmarcarCampanha = false;
            }
        }

        function currentChatQueueAgrupado(nome) {

            let retorno = []
            for (const chat of store.state.chatsTableData.filter(filterByCampanha)) {
                if (chat.customVariables && chat.customVariables['@motivo'] === nome)
                    retorno.push(chat)
            }
            return retorno
        }

        const getMaxAtendimento = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("maxAtendimento", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    maxAtendimento.value = conf[0].valor
                }
            }
        }


        const getClienteAvaliable = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.infocliente", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    clienteAvailable.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        const getBuscaAtendimento = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.busca_atendimento", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    stateLocal.funcaoBuscaAtendimento = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }
        const getBuscaAtendimentoHsm = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.busca_atendimento_hsm", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    stateLocal.funcaoBuscaAtendimentoHsm = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }


        const getTimeoutAtendimentoCampanha = async (campanha) => {
            let timeout = null
            if (store.state.usuario) {
                let conf = findConfiguracao("timeout.atendimento.cliente", store.state.usuario.empresaId, campanha);
                if (conf.length != 0) {
                    timeout = conf[0].valor
                }
            }
            return timeout
        }

        const getTabTimeoutCampanha = async (campanha) => {
            let tabTimeout = null
            if (store.state.usuario) {
                let conf = findConfiguracao("timeout.atendimento.cliente.tabulacao", store.state.usuario.empresaId, campanha);
                if (conf.length != 0) {
                    let tab = conf[0].valor.split("|");
                    tabTimeout = {
                        id: parseInt(tab[0]),
                        nome: tab[1]
                    };
                }
            }
            return tabTimeout
        }

        const getAlarmeAtendimentoCampanha = async (campanha) => {
            let tempoAlarme = []
            if (store.state.usuario) {
                let conf = findConfiguracao("alarme.atendimento.tempo", store.state.usuario.empresaId, campanha);
                if (conf.length != 0) {
                    tempoAlarme = conf[0].valor.split("|");
                }

            }
            return tempoAlarme
        }

        const getMsgAlarmeCampanha = async (campanha) => {
            let msgAlarme = []
            if (store.state.usuario) {
                let conf = findConfiguracao("alarme.atendimento.mensagem", store.state.usuario.empresaId, campanha);
                if (conf.length != 0) {
                    msgAlarme = conf[0].valor.split("|");
                }

            }
            return msgAlarme
        }

        const getVtexAvaliable = async () => {
          if (store.state.usuario) {
              let conf = findConfiguracao("fonte.vtex", store.state.usuario.empresaId);
              if (conf.length != 0 && conf[0].valor.toLowerCase() === 'true') {
                  store.commit('ath/setVetex', true);
              }
          }
        }

        //async function sendMessageChatId(chatQueue, msg, isFinished = false, tabulacao = "", mediaId = "") {
        function sendMessageChatId(chatQueue, msg, isFinished = false, tabulacao = "") {
            console.log("Método SendMessageChatId");
            console.log("chatQueue: ", chatQueue);
            console.log("MediaId: ", chatQueue.customVariables.MediaId);
            let mediaIdgupshup = chatQueue.customVariables.MediaId;

            //03.04.2023 - Ivanildo Bacelar - Implementar envio de mensagens Paneas
            if (isMessageSendByPaneas(chatQueue.empresaId) == true ) {
                if (msg != "{END}{END}{END}") {
                    try {
                      
                        console.log("Msg diferente de {END} PANEAS")

                        let idConversa = chatQueue.customVariables["@ExternalChatId"] || chatQueue.chatId.toString()
                        let paneasRequest = {
                            idconversa: idConversa,
                            mensagem: msg,
                            encerrarconversa: isFinished ? '1' : '0',
                            nomeoperador: nomeUsuario.value,
                            email: emailUsuario.value,
                            tabulacaoencerramento: tabulacao
                        }
                        let paneasUrl = numeroEnterprise.value.url;
                        let r = paneas.sendMessage(paneasUrl, paneasRequest); //await paneas.sendMessage(paneasUrl, paneasRequest);
                        return addToChatHistory(msg, chatQueue)
                    } catch (error) {
                        console.log("sendMessageChatId.Paneas", error)
                    }
                } else {
                    return addToChatHistory(msg, chatQueue);
                }
            }
            else if(isMessageSendByGupshup(chatQueue.empresaId, mediaIdgupshup) == true)
            {
                if(msg != "{END}{END}{END}")
                {
                    try {
                        console.log(">>>>>> chatQueue gupshup: ", chatQueue);
                        console.log(">>>>>> chatQueue gupshup: ", chatQueue.empresaId);
                        console.log(">>>>>> numeroEnterprise.value.url: "+ numeroEnterprise.value.url)
                                                
                        RabbitProducer(msg, chatQueue);
                        return addToChatHistory(msg, chatQueue);
                    } catch (error) {
                        console.log("sendMessageChatId.Gupshup", error)
                    }
                }
            }    
            else if (chatQueue.channel === constants.TipoCanal.indexOf("WHATSAPP") ||
                chatQueue.channel === constants.TipoCanal.indexOf("WHATSAPPBUSINESS")) {

                console.log("WhatsApp");
                //await store.dispatch('getConectionChat', {
                store.dispatch('getConectionChat', {
                    chatQueue: chatQueue
                });
                try {
                    console.log("sendMessageHermesClient");
                    console.log("msg: ", msg);
                    console.log("chatQueue: ", chatQueue);
                    const r = store.dispatch('sendMessageHermesClient', { //await store.dispatch('sendMessageHermesClient', {
                        msg: msg,
                        chatQueue: chatQueue
                    })
                    return addToChatHistory(msg, chatQueue, undefined, r);
                } catch (e) {
                    //console.log('Erro envio msg para:' + chatQueue.chatId + '|' + msg)
                    console.log('Error: ', e)
                    console.log('Msg: ', msg)
                };
            } else if (chatQueue.channel === constants.TipoCanal.indexOf("TELEGRAM")) {
                //await store.dispatch('getConectionChat', {
                store.dispatch('getConectionChat', {
                    chatQueue: chatQueue
                });
                try {
                    const r = store.dispatch('sendMessageTelegram', {//await store.dispatch('sendMessageTelegram', {
                        msg: msg,
                        chatId: chatQueue
                    })
                    return addToChatHistory(msg, chatQueue);
                } catch (e) {
                    //console.log('Erro envio msg para:' + chatQueue.chatId + '|' + msg)
                };
            } else if (chatQueue.channel === constants.TipoCanal.indexOf("WEBCHAT")) {
                let hub = store.dispatch('getConectionChat', {//await store.dispatch('getConectionChat', {
                    chatQueue: chatQueue
                });
                const response = store.dispatch('sendMessageChatHubChatId', {//await store.dispatch('sendMessageChatHubChatId', {
                    msg: msg,
                    chatQueue: chatQueue,
                    hub: hub
                });
                if (!response) {
                    //console.log('Erro envio msg para:' + chatQueue.chatId + '|' + msg)
                } else {
                    return addToChatHistory(msg, chatQueue)
                }
            } else if (isMarketplace(chatQueue.channel)) {
                const respMarketplace = addToMarketplace(msg, chatQueue) //await addToMarketplace(msg, chatQueue)
                if (!respMarketplace) {
                    //console.log('Erro envio msg para:' + chatQueue.chatId + '|' + msg)
                } else {
                    return addToChatHistory(msg, chatQueue)
                }
            } else if (chatQueue.channel === constants.TipoCanal.indexOf("FACEBOOK") ||
                chatQueue.channel === constants.TipoCanal.indexOf("INSTAGRAM")) {
                const respFacebook = addToSocialNetwork(msg, chatQueue) //await addToSocialNetwork(msg, chatQueue)
                if (!respFacebook) {
                    //console.log('Erro envio msg para:' + chatQueue.chatId + '|' + msg)
                } else {
                    return addToChatHistory(msg, chatQueue)
                }
            } else {
                console.log("Else addToChatHistory");
                return addToChatHistory(msg, chatQueue);
            }

        }

        function RabbitProducer(msg, chatQueue, email, resp)
        {
            try 
            {
                var dataFixa = moment('1999-01-01');
                if (chatQueue) {
                    let messageId = resp && resp.data && resp.data.message && resp.data.message.id ? resp.data.message.id : null
                    let message = {
                        chatUUID: chatQueue.chatUUID,
                        empresaId: chatQueue.empresaId,
                        channel: chatQueue.channel,
                        message: msg,
                        agentId: chatQueue.agentId,
                        chatId: chatQueue.chatId,
                        flowId: chatQueue.flowUUID,
                        stepFlowId: 0,
                        stepName: "Atendimento Humano",
                        incoming: false,
                        timestamp: dataFixa.format(),
                        protocol: chatQueue.protocol,
                        messageId: messageId
                    };
                    if (email !== undefined) {
                        message.email = email;
                    }
                    console.log("enviando payload...")
                    //let mediaIdgupshup = store.state.selectedChatQueue.customVariables['MediaId'];
                    console.log("ChatQueue: ", chatQueue)
                    let mediaIdgupshup = chatQueue.customVariables.MediaId;
                    ChatService.SendMessageGupshup(message, mediaIdgupshup)
                }
                
            } catch (error) 
            {
                console.log("RabbitProducer", error);
            }
        }
        async function verificaSaida() {

            const array = store.state.chatsTableData;

            listaChat.value = []
            listaChat.value.push(array);

            for (let [i, chat] of listaChat.value[0].entries()) {

                let motivo = "";
                try {
                    console.log("getHistoryByChatUUI home: ", chat.empresaId)
                    const chatResponse = await ChatService.getHistoryByChatUUI(chat.chatUUID, chat.chatId, chat.empresaId);

                    if (chatResponse.data.length > 0) {

                        let ultimaMsg = chatResponse.data[chatResponse.data.length - 1].message.toUpperCase().trim();

                        if ((chatResponse.data[chatResponse.data.length - 1].incoming == false && ultimaMsg == "ATENDIMENTO FINALIZADO. RETORNANDO PARA A ANA!")) {

                            let newDate = new Date(chatResponse.data[chatResponse.data.length - 1].timestamp);
                            let canal = constants.TipoCanal[chatResponse.data[chatResponse.data.length - 1].channel];
                            if (chat.customVariables && chat.customVariables['@motivo']) {
                                motivo = chat.customVariables['@motivo'];
                            }

                            var saida = new Object();
                            saida.numID = chat.chatId;
                            saida.dataHora = (newDate.getDate() + "/" + ((newDate.getMonth() + 1)) + "/" + (newDate.getFullYear()) + "  " + (newDate.getHours()) + ":" + (newDate.getMinutes()) + ":" + (newDate.getSeconds()));
                            saida.canal = canal;
                            saida.motivo = motivo;
                            if (objFimAtendimento.value.map(x => x.numID).indexOf(saida.numID) == -1) {
                                saida.show = true;
                                objFimAtendimento.value.push(saida);
                                $("#idModalSair").modal({
                                    backdrop: 'static',
                                    keyboard: false
                                });
                            }
                        }
                    }
                } catch (e) {
                    //console.log(e)

                }
            }
            return true
        }

        function fecharModal() {
            $('#idModalSair').modal('hide');
            for (let [i, chat] of objFimAtendimento.value.entries()) {
                chat.show = false
            }
        }

        async function verificaAlertaTimeout() {
            const array = store.state.chatsTableData;
            for (let [i, chat] of array.entries()) {
                if (chat.channel != constants.TipoCanal.indexOf("EMAIL") &&
                    !isMarketplace(chat.channel) &&
                    chat.customVariables.agentId != "") {
                    let now = moment()
                    let lastMessage = moment()
                    if (chat.lastMessage != '0001-01-01T00:00:00Z') {
                        lastMessage = moment(chat.lastMessage)
                    }
                    const dur = moment.duration(now.diff(moment(lastMessage))).as('seconds');
                    let campanha = listCampanhasAtivas.value.find(x => x.nome == chat.queueId)
                    let timeoutCampanha = await getTimeoutAtendimentoCampanha(campanha ? campanha.id : null)
                    let tempoAlarme = await getAlarmeAtendimentoCampanha(campanha ? campanha.id : null)
                    let tempoTotal = parseInt(timeoutCampanha) + parseInt(tempoAlarme);

                    if (timeoutLastMessage[chat.chatId] == undefined || chat.customVariables.incoming == "True") {
                        timeoutLastMessage[chat.chatId] = { "dur": dur, "flag": true, "tempoAviso": 0 }
                    }

                    if (timeoutLastMessage[chat.chatId].flag != false) {
                        timeoutLastMessage[chat.chatId].dur = dur;
                    } else {
                        timeoutLastMessage[chat.chatId].dur = dur + timeoutLastMessage[chat.chatId].tempoAviso;
                    }

                    avisoAgente(chat, false);

                    if (timeoutCampanha && timeoutCampanha != 0 && timeoutLastMessage[chat.chatId].dur >= tempoTotal &&
                        chat.customVariables.incoming == "False") {
                        let tabCampanha = await getTabTimeoutCampanha(campanha ? campanha.id : null)
                        await finalizarAtendimentChat(chat, tabCampanha)
                        delete timeoutLastMessage[chat.chatId]
                    } else {
                        let msgAlarmeCampanha = await getMsgAlarmeCampanha(campanha ? campanha.id : null)
                        for (let [j, alerta] of tempoAlarme.entries()) {
                            if (alerta != 0) {
                                let msgAlarme = localStorage.getItem('msgAlarme') ? JSON.parse(localStorage.getItem("msgAlarme")) : []
                                if (dur >= alerta && chat.customVariables.incoming == "False" && timeoutLastMessage[chat.chatId].flag == true) {
                                    // msg
                                    if (msgAlarme.length > 0) {
                                        let ind = msgAlarme.findIndex(x => x.chave == chat.chatId)
                                        if (ind != -1) {
                                            if (msgAlarme[ind].valor < j) {
                                                msgAlarme[ind].valor = j
                                                timeoutLastMessage[chat.chatId] = { "dur": 0, "flag": false, "tempoAviso": dur }

                                                localStorage.setItem("msgAlarme", JSON.stringify(msgAlarme))
                                                await sendMessageChatId(chat, msgAlarmeCampanha[j].replace("{0}", constants.TipoCanal[chat.channel]))
                                            }
                                        } else {
                                            let item = {
                                                chave: chat.chatId,
                                                valor: j
                                            }
                                            msgAlarme.push(item)
                                            timeoutLastMessage[chat.chatId] = { "dur": 0, "flag": false, "tempoAviso": parseInt(dur) }

                                            localStorage.setItem("msgAlarme", JSON.stringify(msgAlarme))
                                            await sendMessageChatId(chat, msgAlarmeCampanha[j].replace("{0}", constants.TipoCanal[chat.channel]))
                                        }
                                    } else {
                                        let item = {
                                            chave: chat.chatId,
                                            valor: j
                                        }
                                        msgAlarme.push(item)
                                        timeoutLastMessage[chat.chatId] = { "dur": 0, "flag": false, "tempoAviso": parseInt(dur) }

                                        localStorage.setItem("msgAlarme", JSON.stringify(msgAlarme))
                                        await sendMessageChatId(chat, msgAlarmeCampanha[j].replace("{0}", constants.TipoCanal[chat.channel]))

                                    }
                                } else {
                                    if (msgAlarme.length > 0) {
                                        let ind1 = msgAlarme.findIndex(x => x.chave == chat.chatId)
                                        if (ind1 != -1 && ind1 >= j) {
                                            let k = j - 1
                                            if (k < 0) {
                                                store.dispatch('clearMsgAlarme', chat.chatId);
                                            } else {
                                                msgAlarme[ind1].valor = k
                                                localStorage.setItem("msgAlarme", JSON.stringify(msgAlarme))
                                            }
                                        }
                                    }
                                }
                            }
                        } // for
                    }
                }
            }
        }

        async function finalizarAtendimentChat(chat, tabTimeout) {
            let chatId = chat.chatId;
            let tab = {
                id: -1,
                nome: tm('finalizadoSemTab')
            };
            if (tabTimeout) {
                tab = tabTimeout;
            }
            try {
                const response = await ChatService.FinishItemWithTab(chat.uuid, tab)
                if (200 === response.status) {
                    // if (!isEmbedded.value) window.location.reload(true);
                    let campanha = listCampanhasAtivas.value.find(x => x.nome == chat.queueId);
                    let campanhaId = null;
                    if (campanha != {}) {
                        campanhaId = campanha.id;
                    }
                    let msgFinalizacao = findConfiguracao("timeout.atendimento.cliente.mensagem", chat.empresaId, campanhaId);
                    if (msgFinalizacao.length > 0 && chat.channel != constants.TipoCanal.indexOf("EMAIL") &&
                        !isMarketplace(chat.channel)) {
                        // if (!isEmbedded.value) window.location.reload(true);
                        await sendMessageChatId(chat, msgFinalizacao[0].valor, true, tab.nome)
                    }
                    if (chat.channel == constants.TipoCanal.indexOf("WEBCHAT")) {

                        await sendMessageChatId(chat, "{END}{END}{END}", true, tab.nome)
                    }
                    let index = objFimAtendimento.value.map(x => x.numID).indexOf(chat.chatId)
                    if (index != -1) {
                        objFimAtendimento.value.splice(index, 1);
                    }
                }
                // if (!isEmbedded.value) window.location.reload(true);
            } catch (error) {
                console.debug(error);
                //  if (!isEmbedded.value) window.location.reload(true)
                console.debug('Erro finalizar atendimento')
            } finally {
                if (listAgentMsg.value != undefined) {
                    listAgentMsg.value = listAgentMsg.value.filter(x => x.chat.chatUUID != chat.chatUUID);
                }
                await getChats()
                if (tagsAvailable.value) {
                    autocompleteItems.value = []
                    autocompleteTag.value = ""
                    autocompleteTags.value = []
                }
                store.dispatch('ath/clearCountProduct', chatId);
                store.dispatch('clearMsgAlarme', chatId);
                store.dispatch('clearIsNew', chatId);
                setMainTab(false);
                store.commit('setChatMessages', []);
                store.commit('setChatMessagesOld', []);
                store.commit('setChatBody', null);
            };
        }

        const getAgendaAvaliable = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.agenda", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    agendaAvailable.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        const getAutocadastrozappag = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.infocliente.autocadastrozappag", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    autocadastrozappag.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        const getMsgRapidaAvaliable = async () => {
            if (store.state.usuario) {
                                let conf = findConfiguracao("funcao.mensagem_rapida", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    msgRapidaAvailable.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        function getNumeroEnterprise() {
            NumeroEnterpriseService.GetNumberByEmpresa({
                empresaId: store.state.usuario.empresaId,
                noSmbFilter: true
            })
                .then((response) => {
                    if (response.data && response.data.length >= 0) {
                        numeroEnterprise.value = response.data[0]
                    }
                })
                .catch((error) => { })
        }

        function setNovoAtendimento() {
            telefoneAtendimento.value = ''
        }

        function gerarAtendimento() {
            if (!telefoneAtendimento.value) {
                document.getElementById("inputTel").focus();
                toast.warning(tm('erroWhatsapp'))
                return false
            }

            if (telefoneAtendimento.value.length != 19 && store.state.usuario.empresa.paisSigla == 'BR') {
                document.getElementById("inputTel").focus();
                toast.warning(tm('erro2Whatsapp'))
                return false
            }

            let mediaId = localStorage.getItem("mediaId")
            if ((!mediaId || mediaId == null || mediaId == 'null') && (!numeroEnterprise.value || !numeroEnterprise.value.mediaId)) {
                toast.warning(tm('erroGerarAth01'))
                return false
            }
            let chatAth = telefoneAtendimento.value.replaceAll('+', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '').replaceAll(' ', '')
            for (const chat of store.state.chatsTableData) {
                if (chat.chatId === chatAth) {
                    document.getElementById("inputTel").focus();
                    toast.warning(tm('erroGerarAth02'))
                    return false
                }
            }
            let myuuid = uuidv4()
            let custom = {
                '@idLoja': store.state.usuario.empresa.idLojaManager ? store.state.usuario.empresa.idLojaManager : '',
                'MediaId': numeroEnterprise.value ? numeroEnterprise.value.mediaId : (mediaId ? mediaId : '')
            }
            let param = {
                empresaId: store.state.usuario.empresaId,
                flowUUID: numeroEnterprise.value ? numeroEnterprise.value.roboFlowId : 'ATH Chat',
                chatUUID: myuuid,
                flowName: 'ATH Chat',
                channel: numeroEnterprise.value && numeroEnterprise.value.usuario != 'smbdummy' ?
                    constants.TipoCanal.indexOf("WHATSAPP") : constants.TipoCanal.indexOf("WHATSAPPBUSINESS"),
                priority: 50,
                GoalPoint: false,
                queueId: 'ATH' + store.state.usuario.empresaId,
                websocket: '',
                chatId: chatAth,
                agentId: store.state.usuario.id,
                instanceId: 'SMB'
            }
            ChatService.GerarAtendimento(custom, param)
                .then((response) => {
                    toast.info(tm('msgGerarAth'));
                }).catch((error) => {
                    console.debug(error)
                }).finally(() => {
                    $(this.$refs.modalNovoAtendimento).modal('hide');
                    getChats()
                })
        }

        function changeLang(lang) {
            locale.value = lang;
            sessionStorage.setItem("lang", lang);
        }

        const getAvisoAthFinalizadoAvaliable = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("aviso.atendimento.finalizado", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    avisoAthFinalizado.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        const getTagsAvaliable = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.conversationtag", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    tagsAvailable.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        const getTagsCadastroAvaliable = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.conversationtag.cadastroatendente", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    tagsCadastroAvailable.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        const getTags = async () => {
            try {
                let response = await TagService.GeTagByEmpresa({
                    empresaId: store.state.usuario.empresaId
                })
                autocompleteItems.value = response.data
            } catch (error) {
                //console.log(error)
                autocompleteItems.value = []
            }
        }

        const getTagsChat = async (arr) => {
            try {
                for (let [i, item] of arr.entries()) {
                    let tagIncluir = autocompleteItems.value.find(x => x.id == item.id);
                    if (tagIncluir) {
                        autocompleteTags.value.push({
                            id: tagIncluir.id,
                            text: tagIncluir.text,
                            color: tagIncluir.color
                        })
                    }
                }
            } catch (error) {
                //console.log(error)
            }
        }

        async function incluiTag(obj) {
            obj.tag.text = obj.tag.text.trim()
            let tag = autocompleteTags.value.find(x => x.text.trim().toLowerCase() == obj.tag.text.toLowerCase());
            if (!tag) {
                try {
                    autocompleteTag.value = ""
                    let tagIncluir = autocompleteItems.value.find(x => x.text.trim().toLowerCase() == obj.tag.text.toLowerCase());
                    if (!tagIncluir) {
                        if (tagsCadastroAvailable.value) {
                            let registro = {
                                text: obj.tag.text,
                                user: store.state.usuario.email ? store.state.usuario.email : store.state.usuario.nome
                            }
                            const response = await TagService.AddTag(store.state.usuario.empresaId, registro)
                            obj.tag.id = response.data.id
                            getTags()
                            obj.addTag()
                        }
                    } else {
                        obj.tag.id = tagIncluir.id
                        obj.tag.color = tagIncluir.color
                        obj.addTag()
                    }
                } catch (error) {
                    //console.log(error)
                    toast.warning(tm('erroTag02'))
                }
            }
        }

        async function atualizaTags(newTags) {
            autocompleteTags.value = newTags
            try {
                const response = await TagService.UpdateTagChat(store.state.selectedChatQueue.chatUUID, newTags)
            } catch (error) {
                toast.warning(tm('erroTag03'))
                //console.log(error)
            }

        }
        function VerificarMsgTransferencia(mensagem)
        {
            let isIncoming = mensagem.incoming;
            let msg = mensagem.message;
            if(!isIncoming)
            {
                if(!msg.startsWith('Operador de origem:'))
                    return true;
                else
                    return false;
            }
            else
                return true;
        }
        function getMentionedMessage(messageId) {
            let conteudo = ""
            if (currentChatMessages.value && currentChatMessages.value.length > 0) {
                let msg = currentChatMessages.value.find(item => item.messageId && item.messageId === messageId)
                if (msg) {
                    conteudo = msg.message
                }
            }
            return conteudo
        }

        function getMentionedFrom(messageId) {
            let conteudo = ""
            if (currentChatMessages.value && currentChatMessages.value.length > 0) {
                let msg = currentChatMessages.value.find(item => item.messageId && item.messageId === messageId)
                if (msg) {
                    conteudo = msg.incoming ? msg.chatId : 'Você'
                }
            }
            return conteudo
        }

        function qtdNewMsgTela(chatId) {
            if (qtdNewMsg.value && qtdNewMsg.value[chatId] && qtdNewMsg.value[chatId] > 0) {
                return qtdNewMsg.value[chatId]
            } else {
                return ""
            }
        }

        async function atualizaDataHoraKeepAlive() {
            if (store.state.usuario.sessaoUsuario) {
                //console.log("atualizaDataHoraKeepAlive")
                //console.log(await UsuarioService.UpdateSessaoUsuarioDataHoraKeepAlive(store.state.usuario.sessaoUsuario[0].id));

            }
        }

        async function verificaStatusUsuario() {
            try {

                let isLogged = !(store.state.usuario == null);
                if (isLogged) {
                    let response = await UsuarioService.GetUsuarioById(store.state.usuario.id);
                    if (!response.data.isLogged) {
                        logout();
                    }
                    if (store.state.usuario.statusId != response.data.statusId) {
                        store.commit('setStatusUsuario', response.data.statusId);
                        statusSelected.value = response.data.statusId;
                    }
                }
            } catch (error) {
                //console.log("Erro ao Verificar o Status");
                //console.log("Erro: ", error)
            }
        }

        function setPreAtendimento() {
            let preAtendimento = store.state.listConfiguracoes.filter(y => y.chave == "login.status.pausa.automatica" && y.empresaId == store.state.usuario.empresaId);
            if (preAtendimento.length != 0) {
                let preAtendStatusId = store.state.listStatus.filter(y => y.nome == "PreAtendimento" && y.empresaId == store.state.usuario.empresaId);
                statusSelected.value = preAtendStatusId[0].id;
            } else {
                statusSelected.value = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).statusId : 0;
            }

        }

        const getHistoricoAvailable = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.historico_atendimento", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    historicoAvailable.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }
        const getHistoricoHsmAvailable = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("funcao.historico_envio_hsm", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    historicoHsmAvailable.value = conf[0].valor.toLowerCase() === 'true' ? true : false;
                }
            }
        }

        function favicon(isNew) {

            var favicon = document.getElementById('favicon');
            var unreadMessage = isNew.filter(x => x.valor == true).length;

            if (unreadMessage > 0) {

                var faviconSize = 16;

                var canvas = document.createElement('canvas');
                canvas.width = faviconSize;
                canvas.height = faviconSize;

                var context = canvas.getContext('2d');
                var img = document.createElement('img');
                img.setAttribute('id', 'imgUnreadMessage');
                img.src = favicon.href;

                img.onload = () => {
                    // Draw Original Favicon as Background
                    context.drawImage(img, 0, 0, faviconSize, faviconSize);

                    // Draw Notification Circle
                    context.beginPath();
                    context.arc(canvas.width - faviconSize / 3, faviconSize / 3, faviconSize / 3, 0, 2 * Math.PI);
                    context.fillStyle = '#FF0000';
                    context.fill();

                    // Draw Notification Number
                    context.font = '10px "helvetica", sans-serif';
                    context.textAlign = "center";
                    context.textBaseline = "middle";
                    context.fillStyle = '#FFFFFF';
                    context.fillText(unreadMessage, canvas.width - faviconSize / 3, faviconSize / 3);

                    // Replace favicon
                    favicon.href = canvas.toDataURL('image/png');
                };
            } else {
                favicon.setAttribute("href", process.env.BASE_URL + "favicon.ico");
            }

        }

        const marketplaceAvailable = computed(() => {
            let chatSelecionado = selectedChatQueue.value;
            if (store.state.usuario && chatSelecionado) {
                let campanha = store.state.minhasCampanhas.find(x => x.nome == chatSelecionado.queueId);
                let campanhaId = campanha ? campanha.id : null
                let conf = findConfiguracao("funcao.marketplace", store.state.usuario.empresaId, campanhaId);
                if (conf.length != 0) {
                    return !!store.state.selectedChatQueue && conf[0].valor.toLowerCase() === 'true';
                }
            }
            return false;
        });

        const pluginMarketplace = computed(() => {
            if (store.state.usuario) {
                let pluginAtivo = findConfiguracao("plugin.marketplace", store.state.usuario.empresaId);
                if (pluginAtivo.length > 0 && pluginAtivo[0].valor.trim() != "") {
                    let campanhas = store.state.minhasCampanhas;
                    for (let campanha of campanhas) {
                        let conf = findConfiguracao("funcao.marketplace", store.state.usuario.empresaId, campanha.id);
                        if (conf.length != 0 && conf[0].valor.toLowerCase() === 'true') {
                            return true;
                        }
                    }
                }
                return false;
            }
            return false;
        });

        async function setMarketplace() {
            this.$refs.marketplaceCmp.setPedido()
            store.commit(mutationsTypes.MARKETPLACE);
        }


        function isMarketplace(channel) {
            return channel == constants.TipoCanal.indexOf("MERCADOLIVRE")
            // || channel == constants.TipoCanal.indexOf("AMAZON")
        }
        
        function getSla(chatQueue) {
            return chatQueue.customVariables['@sla'] ? chatQueue.customVariables['@sla'] + ' dia(s)' : ""
        }

        async function addToMarketplace(msg, chatQueue) {
            try {
                // TODO - enviar msg marketplace
                //console.log('msg para marketplace:', chatQueue, msg)
                let message = {
                    text: msg,
                    CustomVariables: chatQueue.customVariables
                };
                const response = await MarketplaceService.AddToMarketplace(message)
                //console.log('response:', response.data)
                return true;
            } catch (err) {
                //console.log('erro facebook/messenger:', err)
                return false;
            }
        }

        async function addToSocialNetwork(msg, chatQueue) {
            try {
                let message = {
                    to: chatQueue.chatId,
                    text: msg,
                    type: "",
                    url: ""
                };
                if (chatQueue.channel === constants.TipoCanal.indexOf("FACEBOOK")) {
                    //console.log('enviando facebook/messenger:', message)
                    const response = await MessageService.SendMessageFacebook(message)
                    //console.log('response:', response.data)
                    return true;
                }
                if (chatQueue.channel === constants.TipoCanal.indexOf("INSTAGRAM")) {
                    //console.log('enviando instagram:', message)
                    const response = await MessageService.SendMessageInstagram(message)
                    //console.log('response:', response.data)audio
                    return true;
                }

            } catch (err) {
                //console.log('erro facebook/messenger:', err)
                return false;
            }
        }

        async function addFileToSocialNetwork(msg, chatQueue) {
            try {
                let _tipoFolder = HermesApiService.fetchTypeAndFolder(msg);
                const fileSplit = msg.split('\|');
                let message = {
                    to: chatQueue.chatId,
                    text: (_tipoFolder.type !== 'audio' ? (fileSplit.length > 2 ? fileSplit[2] : "") : ''),
                    type: _tipoFolder.type,
                    url: fileSplit[1]
                };
                if (chatQueue.channel === constants.TipoCanal.indexOf("FACEBOOK")) {
                    //console.log('facebook/messenger:', message)
                    const response = await MessageService.SendMessageFacebook(message)
                    //console.log('response:', response.data)
                    return true;
                }
                if (chatQueue.channel === constants.TipoCanal.indexOf("INSTAGRAM")) {
                    //console.log('enviando instagram:', message)
                    const response = await MessageService.SendMessageInstagram(message)
                    //console.log('response:', response.data)
                    return true;
                }
            } catch (err) {
                //console.log('erro', err)
                return false;
            }
        }

        const getAtendimentoPorIndicadores = async () => {
            if (store.state.usuario) {
                let conf = findConfiguracao("distribuidor.automatico.chamada", store.state.usuario.empresaId);
                if (conf.length != 0) {
                    atendimentoPorIndicadores.value = conf[0].valor.toLowerCase() === 'indicadores' ? true : false;
                }
            }
        }

        const isMessageSendByPaneas = function (empresaId) {
            try
            {
                if (findConfiguracao("send_message_by_paneas", empresaId)[0] &&
                findConfiguracao("send_message_by_paneas", empresaId)[0].valor == "true")
                return true
            else
                return false
            }catch(e)
            {
                console.log("Error message send by paneas: ", e);
            }
        }
        const isMessageSendByGupshup = function (empresaId, mediaIdGlobal) {
            try
            {
                console.log("Método isMessageSendByGupshup")
                let chatSelecionado = (selectedChatQueue && selectedChatQueue.value) 
                                        ? selectedChatQueue.value 
                                        : (selectedChatQueue && selectedChatQueue._value) 
                                            ? selectedChatQueue._value 
                                            : null;
                console.log("selectedChatQueue: ", selectedChatQueue)
                console.log("chatSelecionado: ", chatSelecionado)
                console.log("empresaId: " + empresaId)
                let mediaId;
                //let mediaId = store.state.selectedChatQueue.customVariables['MediaId']
                //mediaId = chatSelecionado.customVariables && chatSelecionado.customVariables['MediaId'] ?
                    //chatSelecionado.customVariables['MediaId'] : localStorage.getItem("mediaId");
                //console.log("mediaId: "+ mediaId)

                // Verifica se chatSelecionado é undefined e utiliza mediaIdGlobal como fallback
                if (!chatSelecionado) {
                    console.log("chatSelecionado é undefined, usando mediaId: ", mediaIdGlobal);
                    mediaId = mediaIdGlobal;
                } else {
                    // Obtém mediaId do chatSelecionado ou do localStorage
                    mediaId = chatSelecionado.customVariables && chatSelecionado.customVariables['MediaId'] 
                        ? chatSelecionado.customVariables['MediaId'] 
                        : localStorage.getItem("mediaId");
                }
                
                console.log("mediaId: " + mediaId);

                const configuracao = findConfiguracao("send_message_by_gupshup", empresaId);

                if (configuracao.length > 0) {
                    console.log('Configuração:', configuracao);
                    const valor = configuracao[0].valor.trim();  // Remove espaços em branco
                    console.log('Valor da configuração:', valor);

                    // Verifica se a configuração começa com "true|" e contém o mediaId
                    if (valor.startsWith("true|") && valor.split('|').includes(mediaId)) {
                        console.log('Empresa válida!!!');
                        return true;
                    }
                }

                console.log('Empresa não válida!!!');
                return false;
            }
            catch(e)
            {
                console.log("Error message send by gupshup: ", e);
            }
        }
        const getClassToBackButton = function () {
            let classe = "btn btn-secondary btn-icon btn-minimal btn-sm text-muted d-xl-none"
            if (isDesenrola() == true)
                classe = classe.replace("d-xl-none", "")
            return classe;
        }

        const isDesenrola = function () {
            return process.env.VUE_APP_DESENROLA != undefined && process.env.VUE_APP_DESENROLA == 1
        }

        const exibirBtnAudio = computed(() => {
            if (store.state.usuario) {
                let campanha = store.state.minhasCampanhas.find(x => x.nome == selectedChatQueue.value.queueId);
                let campanhaId = campanha ? campanha.id : null

                if (findConfiguracao("audio.chat.interagev2", store.state.usuario.empresaId, campanhaId)[0] &&
                    findConfiguracao("audio.chat.interagev2", store.state.usuario.empresaId, campanhaId)[0].valor == "false")
                    return false
                else
                    return true
            }
            return true
        });

        const exibirBtnSendAnexo = computed(() => {
            if (store.state.usuario) {
                let campanha = store.state.minhasCampanhas.find(x => x.nome == selectedChatQueue.value.queueId);
                let campanhaId = campanha ? campanha.id : null

                if (findConfiguracao("sendanexo.chat.interagev2", store.state.usuario.empresaId, campanhaId)[0] &&
                    findConfiguracao("sendanexo.chat.interagev2", store.state.usuario.empresaId, campanhaId)[0].valor == "false")
                    return false
                else
                    return true
            }
            return true
        });

        const exibirBtnGerarAtendimento = computed(() => {
            if (store.state.usuario) {
                let campanha = store.state.minhasCampanhas.find(x => x.nome == selectedChatQueue.value.queueId);
                let campanhaId = campanha ? campanha.id : null

                if (findConfiguracao("geraratendimento.chat.interagev2", store.state.usuario.empresaId, campanhaId)[0] &&
                    findConfiguracao("geraratendimento.chat.interagev2", store.state.usuario.empresaId, campanhaId)[0].valor == "false")
                    return false
                else
                    return true
            }
            return true
        });


        //created
        store.dispatch("getCorTema");
        store.dispatch("getTimeZone");
        timezoneDefault.value = store.state.timeZone;
        getListConfiguracoes();
        getListStatus();
        getCampanhasAtivas();
        getMinhascampanhas();
        getListHsm();
        fetchFilaCampanhas();
        //setChats();
        getTopicosMsgRapidas();
        getAllMessages();
        getNumeroEnterprise()
        loadData();
        loadAudio();
        loadAlerta();
        loadStatusUsuario();
        /// if (!isEmbedded.value) {
        //      loadSaidaUsuario();
        //  }

        onMounted(() => {
            setMainTab(false);
        });

        onBeforeUnmount(() => {
            clearInterval(loading.value);
            clearInterval(loadingAlerta.value);
            clearInterval(loadingSaidaUsuario.value);
            clearInterval(loadingStatusUsuario.value);
        });

        return {
            store,
            mutationsTypes,
            constants,
            moment,
            momenttz,
            loading,
            listHSM,
            hsmSelected,
            isHsmAvailable,
            campanhaUsuario,
            mensagemCampanhaUsuario,
            listStatus,
            statusSelected,
            supervisorUsuario,
            findConfiguracao,
            exibirBtnPuxarAtend,
            exibirBtnTransferirAtend,
            exibirBtnDownloadAtend,
            nomeUsuario,
            emailUsuario,
            empresaUsuario,
            currentChatQueue,
            selectedChatQueue,
            currentChatMessages,
            campanhasFilter,
            motivosFilter,
            idDinModalSair,
            message,
            fileSelected,
            fileAnexo,
            listCampanhasAtivas,
            objFimAtendimento,
            campanhaSelected,
            campanhaTransfSelected,
            listAgentes,
            minhaCampanha,
            agenteSelected,
            dataAgendamentoTicket,
            selectedWhatsApp,
            selectedParams,
            listTopicos,
            topicoSelected,
            listMsgRapidas,
            msgRapidaSelected,
            setChats,
            setChatBody,
            setMotivosFilter,
            setProfile,
            setTranslator,
            setNotes,
            setTodo,
            setSettings,
            appBarClear,
            getChats,
            setMainTab,
            logout,
            sendHsm,
            verificaSaida,
            clearHsm,
            Validar,
            sendMessage,
            clearFile,
            sendAnexo,
            onFileChange,
            clearTransferir,
            transferir,
            enviarMsgRapida,
            fecharModal,
            clearMsgRapida,
            temFila,
            campanhaAtendimento,
            campanhaSelecionada,
            puxarAtendimento,
            webFlowConfiguration,
            isNewMessage,
            listTabulacoes,
            listTabulacoes2,
            tabulacaoSelected,
            tabulacaoSelected2,
            carregarTabulacoes,
            finalizarAtendimento,
            instantMessages,
            showInstanMessages,
            setMessage,
            exibeInstantMessages,
            enviarEmail,
            escreverEmail,
            bytesToSize,
            scrollToBottom,
            appendEmoji,
            exportarChat,
            isRecording,
            stopRecord,
            startRecord,
            timeText,
            gravacaoPronta,
            audioPreview,
            playAudioPreview,
            audioGravado,
            fimDaConversa,
            cancelarGravacao,
            enviarGravacao,
            temaEscuro,
            temaMutant,
            isEmbedded,
            atendimentoAvailable,
            setAtendimento,
            sendCatalog,
            sendProductDescription,
            sendMsgChat,
            currentChatQueueAgrupado,
            currentChatQueueSemMotivacao,
            expandirColapsarAgrupamento,
            exibirBtnEditarRemetente,
            changeRemetentePadrao,
            novoRemetenteEmail,
            toggleAppbarMobile,
            toggleATHBar,
            contactListCategorizada,
            getIntroOptions,
            isRemetenteAlterado,
            loadIntroTutorial,
            showIntro,
            showIntroRef,
            setCliente,
            setAgenda,
            clienteAvailable,
            listaAnexoEmail,
            excluirAnexo,
            showBotaoRolagem,
            displayBotaoRolagem,
            scrollToBottomSelected,
            editor,
            editorConfig,
            isloadingEmail,
            timezoneDefault,
            listCategorizada,
            refAtendimento,
            emojiAvailable,
            agendaAvailable,
            autocadastrozappag,
            gerarAtendimento,
            telefoneAtendimento,
            setNovoAtendimento,
            msgRapidaAvailable,
            tm,
            changeLang,
            listMotivoTransf,
            motivoSelected,
            setHistorico,
            setHistoricoHsm,
            autocompleteTag,
            autocompleteTags,
            autocompleteItems,
            filteredItems,
            incluiTag,
            tagsAvailable,
            tagsCadastroAvailable,
            getMentionedMessage,
            VerificarMsgTransferencia,
            atualizaTags,
            qtdNewMsgTela,
            stateLocal,
            setBusca,
            setBuscaHsm,
            setProfilePassword,
            clearFieldsPass,
            saveChangesPass,
            getMentionedFrom,
            historicoAvailable,
            historicoHsmAvailable,
            marketplaceAvailable,
            setMarketplace,
            headerTicketConfiguration,
            isMarketplace,
            getSla,
            pluginMarketplace,
            lastNotifications,
            isMessageSendByPaneas,
            isMessageSendByGupshup,
            getClassToBackButton,
            isDesenrola,
            exibirBtnAudio,
            exibirBtnSendAnexo,
            exibirBtnGerarAtendimento,
            RabbitProducer,
            searchValue
        }

    },

    methods: {
       
        logout: () => {
            let isEmbedded = (sessionStorage.getItem('isEmbedded') ? JSON.parse(sessionStorage.getItem('isEmbedded')) : false)
            if (isEmbedded) {
                localStorage.removeItem("token");
                localStorage.removeItem("usuario");
                localStorage.removeItem("isNew");
                localStorage.removeItem("countProduct");
                store.dispatch('clearStore');
            } else {
                store.dispatch('getChats', {
                    cliente: clienteAvailable.value
                }).then(e => {
                    if (!store.state.chatsTableData || store.state.chatsTableData.length == 0) {
                        let usuario = JSON.parse(localStorage.getItem("usuario"));
                        UsuarioService.FinishUserSession(usuario.id);
                        localStorage.removeItem("token");
                        localStorage.removeItem("usuario");
                        localStorage.removeItem("isNew");
                        localStorage.removeItem("countProduct");
                        store.dispatch('clearStore');
                        router.push("Login");
                    } else {
                        router.replace("/");
                        toast.warning(tm('erroLogout'));
                    }
                });

            }
        }
    }
};
